import {
  Box,
  Flex,
  Text,
  SimpleGrid,
  Td,
  Tr,
  Menu,
  MenuButton,
  MenuItem,
  Image,
  MenuList,
  Spacer,
  RadioGroup,
  Stack,
  Checkbox,
  Divider,
  Radio,
  Th,
  Collapse,
  useDisclosure,
  Heading,
  Textarea,
  VStack,
} from "@chakra-ui/react";
import { Global, css } from "@emotion/react";
import React, { useState, useEffect, useRef } from "react";
import MiniSideBar from "../../components/mini-sidebar";
import SecondaryNav from "../../components/seconday-nav";
import useLoader from "../../components/loader/loaderstates";
import Loader from "../../components/loader/loader";
import { useLocation, useNavigate } from "react-router-dom";
import DoctorCard from "../../components/doctor-card";
import ModalRight from "../../components/modal-right";
import { DropdownInput, PrimaryButton, PrimaryInput, SearchBar, Toaster } from "../../components";
import DynamicModal from "../../components/dynamic-modal";
import moment from "moment";
import SimpleTable from "../../components/simple-table";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css"; // core Swiper styles
import "swiper/css/navigation"; // navigation module styles
import { getCountry } from "../../middleware/services/country";
import { actionAccessMain, downloadDocument, formatDate_Do_MMM_YYYY, formatDate_Do_MMM_YYYY_Time, formatDate_YYYY_MM_DD, formatToDecimal, getCurrency, getLoginID, getPatientId, useScreenType } from "../../auth";
import DatePicker from "../../components/date-picker";
import { format } from "date-fns";
import { COLORS } from "../../components/styles/colors";
import { BookAppointment, DischargeSummaryLogs, documentProcessingStatus, FetchCategories, FetchFilteredFollowupsList, FetchFilteredPrescriptionsList, FetchLogsData, FetchPrescriptionViewDetails, GetFollowupsList, GetImagingList, GetOrderList, GetOrderVaccinationList, getProcedureCategoryData, GetProceduresList, saveImagingNotification, saveLabNotification, saveNotification, saveProcedureNotification } from "../../middleware/services/prescriptions";
import MobileNavbar from "../../components/mobile-navbar";
import MobileSecondaryNav from "../../components/mobile-secondary-navbar";
import { AddLabFee, DeleteLabFee, GetLabList, UpdateLabFee } from "../../middleware/services/billing";
import SimpleTableLabs from "../../components/simple-table-labs";

const DiagnosticIndex = () => {
  const { isLoading, showLoader, dismissLoader } = useLoader();
  const [activeTab, setActiveTab] = useState("labsetup");
  const navigate = useNavigate();
  
  var [labsViewdata, setLabsViewdata] = useState([]);
  var [imagingViewdata, setImagingViewdata] = useState([]);

  let itemPerPageCommonValue = 30;

  let [pagesize, setPagesize] = useState(itemPerPageCommonValue);
  let [pageno, setPageno] = useState(1);

  // states for item count display
  let [countTo, setCountTo] = useState(itemPerPageCommonValue);
  let [countFrom, setCountFrom] = useState(1);
  let [totalExceedsPageCount, setTotalExceedsPageCount] = useState(false);


  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItemCount, setTotalItemCount] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const [showFilterCount, setShowFilterCount] = useState(false);
  var [logsData, setLogsData] = useState(null);
  const showLabLogs = useRef()
  const showImagingLogs = useRef()
  const showProcedureLogs = useRef()
  const tableRef = useRef()
  const screenType = useScreenType()
  const { isOpen, onToggle } = useDisclosure()
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return moment(dateString).format("Do MMM, YYYY");
  };

  const tabChanged = (tab) => {

    // setSearchValue("")
    if (tab === "labsetup") {
      setActiveTab("labsetup");
      // setCountFrom(1)
      // setCountTo(itemPerPageCommonValue)
      // setCurrentPage(1)
      // fetchLabsList();
      fetchLabList();
      // window.open('/labpricing', '_blank')
    } else if (tab === "imagingsetup") {
      setActiveTab("imagingsetup");
      // setCountFrom(1)
      // setCountTo(itemPerPageCommonValue)
      // setCurrentPage(1)
      // fetchImagingsList();
      fetchImagingList()
      // window.open('/imagingpricing', '_blank')
    } else if (tab === "vaccinesetup") {
      setActiveTab("vaccinesetup");
      // setCountFrom(1)
      // setCountTo(itemPerPageCommonValue)
      // setCurrentPage(1)
      // fetchImagingsList();
      fetchVaccineList()
      // window.open('/imagingpricing', '_blank')
    } else if (tab === "proceduresetup") {
      setActiveTab("proceduresetup");
      // setCountFrom(1)
      // setCountTo(itemPerPageCommonValue)
      // setCurrentPage(1)
      // fetchImagingsList();
      fetchProcedureList()
      // window.open('/imagingpricing', '_blank')
    } 
  };

  // ------------------- lAB PRICIING ---------------------------------
  const [actionAccess, setActionAccess] = useState(null);
  // var [doctorid, setDoctorid] = useState(getLoginID());
  var [patientid, setPatientID] = useState("");
  var [lablist, setLabList] = useState(null);
  // const { isLoading, showLoader, dismissLoader } = useLoader();
  // const screenType = useScreenType();
  const [currency, setCurrency] = useState("");
  const [labamount, setLabAmount] = useState("");
  const [labsgst, setLabSGST] = useState("");
  const [labcgst, setLabCGST] = useState("");
  const [ID, setLabID] = useState("");
  const [description, setDescription] = useState("");
  const [labname, setLabName] = useState("");
  const addlabprice = useRef();
  const editlabprice = useRef();
  const { showSuccessToast, showErrorToast } = Toaster();
  const [searchtext, setSerachText] = useState("");
  // const [currentPage, setCurrentPage] = useState(1);
  // const [totalPages, setTotalPages] = useState(0);
  const deletelabprice = useRef();
  // let itemPerPageCommonValue = 50;

  // let [pageno, setPageno] = useState(1);
  // let [pagesize, setPagesize] = useState(itemPerPageCommonValue);

  // states for item count display
  // let [countTo, setCountTo] = useState(itemPerPageCommonValue);
  // let [countFrom, setCountFrom] = useState(1);
  // let [totalExceedsPageCount, setTotalExceedsPageCount] = useState(false);
  // const [totalItemCount, setTotalItemCount] = useState(0);

  // let [currentPage, setCurrentPage] = useState(1);
  // let [totalPages, setTotalPages] = useState(1);

  // const navigate = useNavigate();
  const location = useLocation();

  
  useEffect(() => {
    
    setActionAccess(actionAccessMain(12))
    fetchLabList(pageno);    
    const currency = getCurrency();
    if(currency == "USD"){
      const uscurrency = '$'
      setCurrency(uscurrency);
    }else{
    setCurrency(currency);
    }   
  }, [pageno]);
  const fetchLabList = async (page) => {
    setSerachText("");
  //  alert(countTo)
    showLoader()
    try {
        const result = await GetLabList({ 
          "doctorid":"",
          "type": "lab",
          "pageno":page,
          pagesize
        });
        if (result != null) {
          setLabList(result.output.data);
          if (result && result.output.count === 0 && result.output.pagesize === 0) {
            setTotalPages(1);
          } else {
            setTotalPages(Math.ceil(result.output.count / result.output.pagesize));
          }
          
          setTotalItemCount(result.output.count)
          if (result.output.count < itemPerPageCommonValue) {
           // console.log("if bolock " ,result.output.count + " < " + itemPerPageCommonValue )
            setCountTo(result.output.count);
            setTotalExceedsPageCount(true);
          }else if(result.output.count > itemPerPageCommonValue && page == 1) {
            
          //  console.log("else bolock " ,result.output.count + " > " + itemPerPageCommonValue + " page - "+ page)
            setCountTo(itemPerPageCommonValue);
            setTotalExceedsPageCount(false);
          }
        }else{
          setLabList(null)
          setTotalPages(1);
          dismissLoader();
        }
        dismissLoader();
      } catch (error) {
        console.error("Error in home:", error);
      }
  };
  const handleNextClick = () => {
    // item count logic for next
    //here
   if(countTo + pagesize < totalItemCount){
    setCountTo(countTo + pagesize)
   }else{
     setCountTo(totalItemCount)
   }
   
   setCountFrom(countFrom + pagesize)

    setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
    fetchLabList(currentPage + 1);
    
      
   
  };

  const handlePreviousClick = () => {
      // item count logic for previous
     // setCurrentPage(currentPage - 1);
      
    //console.log(countTo +  " == " + totalItemCount + "| else count to -  " + pagesize)
      if(countTo == totalItemCount){
           //setCountTo(Math.floor(totalItemCount / 10) * 10)
         let updatedCountUnroundedValue  = totalItemCount - pagesize;
        setCountTo(Math.ceil(updatedCountUnroundedValue / itemPerPageCommonValue ) * itemPerPageCommonValue )
      }else{
        setCountTo(countTo - pagesize)
      }
      
      setCountFrom(countFrom - pagesize)

    setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
    fetchLabList(currentPage - 1);
     // alert(currentPage - 1)
  
  };
  const TableHeader = [
    { key: "name", label: "Name" },
    { key: "sgst", label: "SGST" },
    { key: "cgst", label: "CGST" },
    { key: "amount", label: "Amount" },
    { key: "actions", label: "Actions" },

  ];
  const [showMetricsTable, setShowMetricsTable] = useState(false);
   const openaddmodal = ()=>{
        setLabName("");
        setLabCGST("");
        setLabSGST("");
        setLabAmount("");
        setDescription("")
        setRows([{ ...initialRow }]); // Reset to one empty row
        setShowMetricsTable(false); // Hide metrics table by default
        addlabprice.current.openRight()
       }
  const toggleMetricsTable = () => {
  setShowMetricsTable(!showMetricsTable);
  // If showing the table for the first time, ensure there's at least one row
  if (!showMetricsTable && rows.length === 0) {
    setRows([{ ...initialRow }]);
  }
};
  const addLabtest = async() => {
    if(labname == ""){
      showErrorToast("Please specify the test name");
      return false;
    }
    else if (labamount == "") {
         showErrorToast("Please specify the amount");
         return false;
       }else if (labsgst == "") {
         showErrorToast("Please specify the sgst");
         return false;
       } else if (labcgst == "") {
           showErrorToast("Please specify the cgst");
           return false;
       }
       else {   
           let input = {
               "doctorid":"",
               "testname": labname,
               "testdescription": description,
               "totalamount": labamount,
               "sgst": labsgst,
               "cgst": labcgst,
               "islab":"1",
               // Only include labmetrics if the table was shown and has data
      "labmetric": showMetricsTable ? rows.filter(row => 
        row.metricname || row.unit || row.highrange || row.lowrange || row.formula
      ) : []
           }
           try {
             const response = await AddLabFee(input);
             if(response.output.message == "A lab Test with the same name already exists"){
              showErrorToast("Test name already exist")
             }else if(response){
               addlabprice.current.closeRight();
               fetchLabList();
               dismissLoader();
             }else{
               console.log("someting went wrong")
             }
             } catch (error) {
               console.log(error , " error in updating fee")
             }
          
       }
   }
  const editDetailsSetState = (item) =>{
    setLabID(item.id)
    setLabAmount(item.totalamount);
    setLabSGST(item.sgst)
    setLabCGST(item.cgst)
    setLabName(item.type)
    // Populate rows based on labmetric data
  populateRowsFromLabMetric(item.labmetric);
  }
  const openEditModal = (item) => {
    editDetailsSetState(item)
    editlabprice.current.openRight();
  };
    const editLabtest = async() => {
      if(labname == ""){
        showErrorToast("Please specify the test name");
        return false;
      }
     else if (labamount == "") {
          showErrorToast("Please specify the total amount");
          return false;
        }else if (labsgst == "") {
          showErrorToast("Please specify the sgst");
          return false;
        } else if (labcgst == "") {
            showErrorToast("Please specify the cgst");
            return false;
        }
        else {   
            let input = {
                "doctorid":"",
                "testname": labname,
                "testdescription": description,
                "id": ID,
                "totalamount": labamount,
                "sgst": labsgst,
                "cgst": labcgst,
                "islab":"1",
                "labmetric": rows.map(row => ({
                  "metricname": row.metricname,
                  "unit": row.unit,
                  "highrange": row.highrange,
                  "lowrange": row.lowrange,
                  "formula": row.formula
                }))
            }
            showLoader()
            try {
              const response = await UpdateLabFee(input);
              // console.log('responseLabs: ', response)
              if(response.output.isexists == 1){
                showErrorToast('Test name already exists for the same doctor');
                return false;
              }
              if(response){
                showSuccessToast('Lab Test Updated Successfully  ')
                editlabprice.current.closeRight();
                // setCountTo(itemPerPageCommonValue)
                fetchLabList(pageno);
                    dismissLoader();
              }else{
                console.log("someting went wrong")
              }
              dismissLoader();
              } catch (error) {
                console.log(error , " error in updating fee")
              }
           
        }
    }
    const openDeleteModal = (item) => {
      setLabID(item.id)
      setLabName(item.type)
      deletelabprice.current.openModal();
    };
    const deleteLab = async() => {
      showLoader();
            let input = {
                "doctorid":"",
                "testname": labname,
                "id": ID,
                "islab":"1",
            }
            try {
              const response = await DeleteLabFee(input);
              // console.log(response.output.result == "success", " deleted respose ")
              if(response.output.result == "success"){
                // showErrorToast("Lab Test Deleted Successfully!")
                showSuccessToast("Lab Test Deleted Successfully!")
                deletelabprice.current.closeModal();
                fetchLabList();
                    dismissLoader();
              }else{
                console.log("someting went wrong")
              }
              } catch (error) {
                console.log(error , " error in updating fee")
              }
              dismissLoader();
    }
    const searchanything = async (e) => {
         if (e.key === "Enter") {
          showLoader();
          try {
            setPageno(1);
            setPagesize(itemPerPageCommonValue);
            setCountFrom(1);
            setCountTo(itemPerPageCommonValue);
            setCurrentPage(1)

            const result = await GetLabList({
              "doctorid":"",
              "type": "lab",
              searchtext: searchtext,
              "pageno":"1",
              pagesize,
            });
            if (result != null) {
              setLabList(result.output.data);
              if (result && result.output.count === 0 && result.output.pagesize === 0) {
                setTotalPages(1);
              } else {
                setTotalPages(Math.ceil(result.output.count / result.output.pagesize));
              }
              //here
              
              setTotalItemCount(result.output.count)
              if (result.output.count < itemPerPageCommonValue) {
                setCountTo(result.output.count);
                setTotalExceedsPageCount(true);
              }else if(result.output.count > itemPerPageCommonValue && pageno == 1) {
                setCountTo(itemPerPageCommonValue);
                setTotalExceedsPageCount(false);
              }
            }else{
              setLabList(null)
              setTotalPages(1);
              dismissLoader();
            }
            dismissLoader();
          } catch (error) {
            console.error("Error in home:", error);
          }
         } 
      };
      const Filteranything = async (e) => {
          showLoader();
          try {
              setPageno(1);
             setPagesize(itemPerPageCommonValue);
             setCountFrom(1);
             setCountTo(itemPerPageCommonValue);
             setCurrentPage(1)

            const result = await GetLabList({
              "doctorid":"",
              "type": "lab",
              searchtext: searchtext,
              "pageno":"1",
               pagesize,
            });
            if (result != null) {
              setLabList(result.output.data);
              if (result && result.output.count === 0 && result.output.pagesize === 0) {
                setTotalPages(1);
              } else {
                setTotalPages(Math.ceil(result.output.count / result.output.pagesize));
              }
              //here
              console.log(result.output.count , " result.output.count")
              setTotalItemCount(result.output.count)
              if (result.output.count < itemPerPageCommonValue) {
                setCountTo(result.output.count);
                setTotalExceedsPageCount(true);
              }else if(result.output.count > itemPerPageCommonValue && pageno == 1) {
                setCountTo(itemPerPageCommonValue);
                setTotalExceedsPageCount(false);
              }
            }else{
              setLabList(null)
              setTotalPages(1);
              dismissLoader();
            }
            dismissLoader();
          } catch (error) {
            console.error("Error in home:", error);
          }
      };
      // const gobackfunction = ()=>{
      //   window.history.back();
      //  }

      const gobackfunction = () => {
        if (window.history.length > 2 && location.key !== "default") {
          window.history.back();
      
          // Fallback if the page does not navigate
          setTimeout(() => {
            if (document.referrer === "" || window.history.length <= 1) {
              navigate("/home");
            }
          }, 500);
        } else {
          navigate("/home");
        }
      };

       const resetFields = () => {
        setCurrentPage(1);
        setPageno(1);
        
        //clear states for correct item count
        setPagesize(itemPerPageCommonValue);
        setCountFrom(1)
        setCountTo(itemPerPageCommonValue)
        setCurrentPage(1)

        fetchLabList(1)
      };

// ------------------------- edit lab row start ---------------------------

const [ inputId , setInputId ] = useState("");
const [rowToDelete, setRowToDelete] = useState(null);
const deleteRowModal = useRef();
const [ labTestDetail , setLabTestDetail] = useState([]);
const [manualreportname, setManualReportName] = useState(null);  

const [rows, setRows] = useState([]);
  const initialRow = {
  metricname: '',
  unit: '',
  highrange: '',
  lowrange: '',
  formula: '',
};
// Function to populate rows when labmetric has data
const populateRowsFromLabMetric = (labmetric) => {
  if (labmetric && labmetric.length > 0) {
    const newRows = labmetric.map(metric => ({
      metricname: metric.metricname || '',
      unit: metric.unit || '',
      highrange: metric.highrange || '',
      lowrange: metric.lowrange || '',
      formula: metric.formula || '',
    }));
    setRows(newRows);
  } else {
    // If no labmetric data, start with one empty row
    setRows([{ ...initialRow }]);
  }
};
const handleMetricNameChange = (name, index) => {
  setInputId(index);
  const newRows = [...rows];
  newRows[index].metricname = name;
  setRows(newRows);
};

const handleUnitChange = (unit, index) => {
  const newRows = [...rows];
  newRows[index].unit = unit;
  setRows(newRows);
};

const handleHighRangeChange = (value, index) => {
  const newRows = [...rows];
  newRows[index].highrange = value;
  setRows(newRows);
};

const handleLowRangeChange = (value, index) => {
  const newRows = [...rows];
  newRows[index].lowrange = value;
  setRows(newRows);
};

const handleFormulaChange = (value, index) => {
  const newRows = [...rows];
  newRows[index].formula = value;
  setRows(newRows);
};
const AddAnotherRowLabTest = () => {
  setRows((prevRows) => [...prevRows, { ...initialRow }]);
  focusInput("LabNameInAdd");
};

const focusInput = (inputId) => {
  setTimeout(() => {
    const element = document.getElementById(inputId);
    if (element) {
      element.focus();
    }
  }, 100);
};
const confirmDeleteRow = (index) => {
  setRowToDelete(index);
  deleteRowModal.current.openModal();
};

const deleteRowHandler = () => {
  const newRows = rows.filter((_, i) => i !== rowToDelete);
  setRows(newRows);
  deleteRowModal.current.closeModal();
};  
  
  // const SubmitForm = async () => {
  //   showLoader();
  //   const isValidRows = (rows, fieldNames) => {
  //     for (const row of rows) {
  //       for (const fieldName of fieldNames) {
  //         if (!row[fieldName]) {
  //           dismissLoader();
  //           // Assuming you have a function to show toast messages
  //           showErrorToast(`Please fill in the ${fieldName == "test_name"? "Test Name": "Result Value"}`);
  //           return false;
  //         }
  //       }
  //     }
  //     return true;
  //   };
  //   if (!isValidRows(rows, ['test_name', 'resultvalue'])) return;
  //     let FinalInput = {
  //       patient_info:{
  //         // name: getPatientFullName(),
  //         // age: getPatientAge(),
  //         // doctor_name: doctorName,
  //         // date_of_report: patientInfo.date_of_report ? patientInfo.date_of_report : moment().format("YYYY-MM-DD"),
  //         // hospital_name: patientInfo.hospital_name,
  //         patientid: getPatientId(),
  //         // activeuserid: getUserID(),
  //       },
  //       report_info:{
  //         type:"labs",
  //         name: manualreportname
  //       },
  //       test_list: rows.map((row) => ({
  //         test_name: row.test_name,
  //         test_unit: row.test_unit,
  //         resultvalue: row.resultvalue,
  //         "upper_bound": row.upper_bound,
  //         "lower_bound": row.lower_bound,
  //       })),
  //     };
  //     showLoader();
  //     const result = await AddMedicalRecord(FinalInput);
  //     if (result.output.result === "success") {
  //       //setShowSuccess(true);
  //         // fetchPatientHealthData()
  //         fetchinvestigationdata(patientid)
  //       showSuccessToast("Report added Successfully!")
  //       editLabtest.current.closeRight();
  //       //setActiveTab("TableViewTab");
  //       // setTimeout(() => {
          
  //       //   window.location.reload()
  //       // }, 500);
  //       //dismissLoader();
  //     } else {
  //       showErrorToast("Somthing went wrong");
  //       dismissLoader();
  //     }
  // };
// ------------------------- edit lab row end ---------------------------

// ------------------------- imaging setup start ---------------------------
  // var [doctorid, setDoctorid] = useState(getLoginID());
  var [patientid, setPatientID] = useState("");
  var [imaginglist, setImagingList] = useState(null);
  // const screenType = useScreenType();
  // const [currency, setCurrency] = useState("");
  // const [labamount, setLabAmount] = useState("");
  // const [labsgst, setLabSGST] = useState("");
  // const [labcgst, setLabCGST] = useState("");
  // const [ID, setLabID] = useState("");
  // const [description, setDescription] = useState("");
  const [imagingname, setImagingName] = useState("");
  const addimagingprice = useRef();
  const editimagingprice = useRef();
  const deleteimagingprice = useRef();

  // const { showSuccessToast, showErrorToast } = Toaster();
  // const [searchtext, setSerachText] = useState("");
  // const [currentPage, setCurrentPage] = useState(1);
  // const [totalPages, setTotalPages] = useState(0);

  // let itemPerPageCommonValue = 50;

  // let [pageno, setPageno] = useState(1);
  // let [pagesize, setPagesize] = useState(itemPerPageCommonValue);

  // // states for item count display
  // let [countTo, setCountTo] = useState(itemPerPageCommonValue);
  // let [countFrom, setCountFrom] = useState(1);
  // let [totalExceedsPageCount, setTotalExceedsPageCount] = useState(false);
  // const [totalItemCount, setTotalItemCount] = useState(0);

  // let [currentPage, setCurrentPage] = useState(1);
  // let [totalPages, setTotalPages] = useState(1);
  // const navigate = useNavigate();
  // const location = useLocation();
  
  useEffect(() => {
    
  setActionAccess(actionAccessMain(12))
    fetchImagingList(pageno);    
    const currency = getCurrency();
    if(currency == "USD"){
      const uscurrency = '$'
      setCurrency(uscurrency);
    }else{
    setCurrency(currency);
    }   
  }, [pageno]);
  const fetchImagingList = async (page) => {
    setSerachText("");
  //  alert(countTo)
    showLoader()
    try {
        const result = await GetLabList({ 
          "doctorid":"",
          "type": "imaging",
          "pageno":page,
          pagesize
        });
        if (result != null) {
          setImagingList(result.output.data);
          if (result && result.output.count === 0 && result.output.pagesize === 0) {
            setTotalPages(1);
          } else {
            setTotalPages(Math.ceil(result.output.count / result.output.pagesize));
          }
          
          setTotalItemCount(result.output.count)
          if (result.output.count < itemPerPageCommonValue) {
           // console.log("if bolock " ,result.output.count + " < " + itemPerPageCommonValue )
            setCountTo(result.output.count);
            setTotalExceedsPageCount(true);
          }else if(result.output.count > itemPerPageCommonValue && page == 1) {
            
          //  console.log("else bolock " ,result.output.count + " > " + itemPerPageCommonValue + " page - "+ page)
            setCountTo(itemPerPageCommonValue);
            setTotalExceedsPageCount(false);
          }
        }else{
          setImagingList(null)
          setTotalPages(1);
          dismissLoader();
        }
        dismissLoader();
      } catch (error) {
        console.error("Error in home:", error);
      }
  };
  const handleImagingNextClick = () => {
    // item count logic for next
    //here
   if(countTo + pagesize < totalItemCount){
    setCountTo(countTo + pagesize)
   }else{
     setCountTo(totalItemCount)
   }
   
   setCountFrom(countFrom + pagesize)

    setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
    fetchImagingList(currentPage + 1);
    
      
   
  };

  const handleImagingPreviousClick = () => {
      // item count logic for previous
     // setCurrentPage(currentPage - 1);
      
    //console.log(countTo +  " == " + totalItemCount + "| else count to -  " + pagesize)
      if(countTo == totalItemCount){
           //setCountTo(Math.floor(totalItemCount / 10) * 10)
         let updatedCountUnroundedValue  = totalItemCount - pagesize;
        setCountTo(Math.ceil(updatedCountUnroundedValue / itemPerPageCommonValue ) * itemPerPageCommonValue )
      }else{
        setCountTo(countTo - pagesize)
      }
      
      setCountFrom(countFrom - pagesize)

    setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
    fetchImagingList(currentPage - 1);
     // alert(currentPage - 1)
  
  };
  const imagingTableHeader = [
    { key: "name", label: "Name" },
    { key: "sgst", label: "SGST" },
    { key: "cgst", label: "CGST" },
    { key: "amount", label: "Amount" },
    { key: "actions", label: "Actions" },

  ];
  const addImaging = async() => {
    if(imagingname == ""){
      showErrorToast("Please specify the name");
      return false;
    }
    else if (labamount == "") {
         showErrorToast("Please specify the total amount");
         return false;
       }else if (labsgst == "") {
         showErrorToast("Please specify the sgst");
         return false;
       } else if (labcgst == "") {
           showErrorToast("Please specify the cgst");
           return false;
       }
       else {   
           let input = {
               "doctorid":"",
               "testname": imagingname,
               "testdescription": description,
               "totalamount": labamount,
               "sgst": labsgst,
               "cgst": labcgst,
               "islab":"0",
           }
           try {
             const response = await AddLabFee(input);
             if(response.output.message == "A Imaging Test with the same name already exists"){
              showErrorToast("Test name already exist")
             }else if(response){
              addimagingprice.current.closeRight();
               fetchImagingList();
              dismissLoader();
             }else{
               console.log("someting went wrong")
             }
             } catch (error) {
               console.log(error , " error in updating fee")
             }
          
       }
   }
  const editImagingDetailsSetState = (item) =>{
    setLabID(item.id)
    setLabAmount(item.totalamount);
    setLabSGST(item.sgst)
    setLabCGST(item.cgst)
    setImagingName(item.type)
    setDescription(item.testdescription || "");

  }
  const openEditImagingModal = (item) => {
    console.log('item Imaging: ', item)
    // editDetailsSetState(item)
    editImagingDetailsSetState(item)
    editimagingprice.current.openRight();
  };
    const editImagingtest = async() => {
      if(imagingname == ""){
        showErrorToast("Please specify the name");
        return false;
      }
     else if (labamount == "") {
          showErrorToast("Please specify the total amount");
          return false;
        }else if (labsgst == "") {
          showErrorToast("Please specify the sgst");
          return false;
        } else if (labcgst == "") {
            showErrorToast("Please specify the cgst");
            return false;
        }
        else {   
            let input = {
                "doctorid":"",
                "testname": imagingname,
                "testdescription": description,
                "id": ID,
                "totalamount": labamount,
                "sgst": labsgst,
                "cgst": labcgst,
                "islab":"0",
            }
            showLoader()
            try {
              const response = await UpdateLabFee(input);
              if(response.output.isexists == 1){
                showErrorToast('Test name already exists for the same doctor');
                dismissLoader();
                return false;
              }
              if(response){
                showSuccessToast('Imaging Updated Successfully  ')
                editimagingprice.current.closeRight();
                fetchImagingList(pageno);
                    dismissLoader();
              }else{
                console.log("someting went wrong")
              }
              dismissLoader();
              } catch (error) {
                console.log(error , " error in updating fee")
              }
           
        }
    }

    const openDeleteImagingModal = (item) => {
      console.log('item: ', item)
      setLabID(item.id)
      setImagingName(item.type)
      deleteimagingprice.current.openModal();
    };
    const deleteImaging = async() => {
      showLoader();
            let input = {
                "doctorid":"",
                "testname": imagingname,
                "id": ID,
                "islab":"1",
            }
            try {
              const response = await DeleteLabFee(input);
              // console.log(response.output.result == "success", " deleted respose ")
              if(response.output.result == "success"){
                // showErrorToast("Imaging Deleted Successfully!")
                showSuccessToast("Imaging Deleted Successfully!")
                deleteimagingprice.current.closeModal();
                fetchImagingList();
                    dismissLoader();
              }else{
                console.log("someting went wrong")
              }
              } catch (error) {
                console.log(error , " error in updating fee")
              }
              dismissLoader();
    }

    const searchanythingimaging = async (e) => {
         if (e.key === "Enter") {
          showLoader();
          try {
            setPageno(1);
             setPagesize(itemPerPageCommonValue);
             setCountFrom(1);
             setCountTo(itemPerPageCommonValue);
             setCurrentPage(1)

            const result = await GetLabList({
              "doctorid":"",
              "type": "imaging",
              searchtext: searchtext,
              "pageno":"1",
              pagesize,
            });
            if (result != null) {
              setImagingList(result.output.data);
              if (result && result.output.count === 0 && result.output.pagesize === 0) {
                setTotalPages(1);
              } else {
                setTotalPages(Math.ceil(result.output.count / result.output.pagesize));
              }
              //here
              
              setTotalItemCount(result.output.count)
              if (result.output.count < itemPerPageCommonValue) {
                setCountTo(result.output.count);
                setTotalExceedsPageCount(true);
              }else if(result.output.count > itemPerPageCommonValue && pageno == 1) {
                setCountTo(itemPerPageCommonValue);
                setTotalExceedsPageCount(false);
              }
            }else{
              setImagingList(null)
              setTotalPages(1);
              dismissLoader();
            }
            dismissLoader();
          } catch (error) {
            console.error("Error in home:", error);
          }
         } 
      };
      const Filteranythingimaging = async (e) => {
          showLoader();
          try {
             setPageno(1);
             setPagesize(itemPerPageCommonValue);
             setCountFrom(1);
             setCountTo(itemPerPageCommonValue);
             setCurrentPage(1)

            const result = await GetLabList({
              "doctorid":"",
              "type": "imaging",
              searchtext: searchtext,
              "pageno":"1",
               pagesize,
            });
            if (result != null) {
              setImagingList(result.output.data);
              if (result && result.output.count === 0 && result.output.pagesize === 0) {
                setTotalPages(1);
              } else {
                setTotalPages(Math.ceil(result.output.count / result.output.pagesize));
              }
              //here
              setTotalItemCount(result.output.count)
              if (result.output.count < itemPerPageCommonValue) {
                setCountTo(result.output.count);
                setTotalExceedsPageCount(true);
              }else if(result.output.count > itemPerPageCommonValue && pageno == 1) {
                setCountTo(itemPerPageCommonValue);
                setTotalExceedsPageCount(false);
              }
            }else{
              setImagingList(null)
              setTotalPages(1);
              dismissLoader();
            }
            dismissLoader();
          } catch (error) {
            console.error("Error in home:", error);
          }
      };
      // const gobackfunction = ()=>{
      //   window.history.back();
      //  }
      const gobackfunctionimaging = () => {
        if (window.history.length > 2 && location.key !== "default") {
          window.history.back();
      
          // Fallback if the page does not navigate
          setTimeout(() => {
            if (document.referrer === "" || window.history.length <= 1) {
              navigate("/home");
            }
          }, 500);
        } else {
          navigate("/home");
        }
      };
       const openaddmodalimaging = ()=>{
        setImagingName("");
        setLabCGST("");
        setLabSGST("");
        setLabAmount("");
        setDescription("")
        addimagingprice.current.openRight()
       }

       const imagingresetFields = () => {
        setCurrentPage(1);
        setPageno(1);

        //clear states for correct item count
        setPagesize(itemPerPageCommonValue);
        setCountFrom(1)
        setCountTo(itemPerPageCommonValue)
        
        fetchImagingList(1)
      };

// ------------------------- vaccine setup start ---------------------------
  // var [doctorid, setDoctorid] = useState(getLoginID());
  var [patientid, setPatientID] = useState("");
  var [vaccinelist, setVaccineList] = useState(null);
  const [vaccinename, setVaccineName] = useState("");
  const addvaccineprice = useRef();
  const editvaccineprice = useRef();
  const deletevaccineprice = useRef();
  
  useEffect(() => {
    
  setActionAccess(actionAccessMain(12))
    fetchVaccineList(pageno);    
    const currency = getCurrency();
    if(currency == "USD"){
      const uscurrency = '$'
      setCurrency(uscurrency);
    }else{
    setCurrency(currency);
    }   
  }, [pageno]);
  const fetchVaccineList = async (page) => {
    setSerachText("");
  //  alert(countTo)
    showLoader()
    try {
        const result = await GetLabList({ 
          "doctorid":"",
          "type": "vaccine",
          "pageno":page,
          pagesize
        });
        if (result != null) {
          setVaccineList(result.output.data);
          if (result && result.output.count === 0 && result.output.pagesize === 0) {
            setTotalPages(1);
          } else {
            setTotalPages(Math.ceil(result.output.count / result.output.pagesize));
          }
          
          setTotalItemCount(result.output.count)
          if (result.output.count < itemPerPageCommonValue) {
           // console.log("if bolock " ,result.output.count + " < " + itemPerPageCommonValue )
            setCountTo(result.output.count);
            setTotalExceedsPageCount(true);
          }else if(result.output.count > itemPerPageCommonValue && page == 1) {
            
          //  console.log("else bolock " ,result.output.count + " > " + itemPerPageCommonValue + " page - "+ page)
            setCountTo(itemPerPageCommonValue);
            setTotalExceedsPageCount(false);
          }
        }else{
          setVaccineList(null)
          setTotalPages(1);
          dismissLoader();
        }
        dismissLoader();
      } catch (error) {
        console.error("Error in home:", error);
      }
  };
  const handleVaccineNextClick = () => {
    // item count logic for next
    //here
   if(countTo + pagesize < totalItemCount){
    setCountTo(countTo + pagesize)
   }else{
     setCountTo(totalItemCount)
   }
   
   setCountFrom(countFrom + pagesize)

    setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
    fetchVaccineList(currentPage + 1);
   
  };

  const handleVaccinePreviousClick = () => {
      // item count logic for previous
     // setCurrentPage(currentPage - 1);
      
    //console.log(countTo +  " == " + totalItemCount + "| else count to -  " + pagesize)
      if(countTo == totalItemCount){
           //setCountTo(Math.floor(totalItemCount / 10) * 10)
         let updatedCountUnroundedValue  = totalItemCount - pagesize;
        setCountTo(Math.ceil(updatedCountUnroundedValue / itemPerPageCommonValue ) * itemPerPageCommonValue )
      }else{
        setCountTo(countTo - pagesize)
      }
      
      setCountFrom(countFrom - pagesize)

    setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
    fetchVaccineList(currentPage - 1);
     // alert(currentPage - 1)
  
  };
  const vaccineTableHeader = [
    { key: "name", label: "Name" },
    { key: "sgst", label: "SGST" },
    { key: "cgst", label: "CGST" },
    { key: "amount", label: "Amount" },
    { key: "actions", label: "Actions" },

  ];
  const addVaccine = async() => {
    if(vaccinename == ""){
      showErrorToast("Please specify the name");
      return false;
    }
    else if (labamount == "") {
         showErrorToast("Please specify the total amount");
         return false;
       }else if (labsgst == "") {
         showErrorToast("Please specify the sgst");
         return false;
       } else if (labcgst == "") {
           showErrorToast("Please specify the cgst");
           return false;
       }
       else {   
           let input = {
               "doctorid":"",
               "testname": vaccinename,
               "testdescription": description,
               "totalamount": labamount,
               "sgst": labsgst,
               "cgst": labcgst,
               "islab":"0",
           }
           try {
             const response = await AddLabFee(input);
             if(response.output.message == "A Vaccine Test with the same name already exists"){
              showErrorToast("Test name already exist")
             }else if(response){
              addimagingprice.current.closeRight();
               fetchVaccineList();
              dismissLoader();
             }else{
               console.log("someting went wrong")
             }
             } catch (error) {
               console.log(error , " error in updating fee")
             }
          
       }
   }
  const editVaccineDetailsSetState = (item) =>{
    setLabID(item.id)
    setLabAmount(item.totalamount);
    setLabSGST(item.sgst)
    setLabCGST(item.cgst)
    setVaccineName(item.type)
    setDescription(item.testdescription || "");

  }
  const openEditVaccineModal = (item) => {
    console.log('item Procedure: ', item)
    // editDetailsSetState(item)
    editVaccineDetailsSetState(item)
    editvaccineprice.current.openRight();
  };
    const editVaccinetest = async() => {
      if(vaccinename == ""){
        showErrorToast("Please specify the name");
        return false;
      }
     else if (labamount == "") {
          showErrorToast("Please specify the total amount");
          return false;
        }else if (labsgst == "") {
          showErrorToast("Please specify the sgst");
          return false;
        } else if (labcgst == "") {
            showErrorToast("Please specify the cgst");
            return false;
        }
        else {   
            let input = {
                "doctorid":"",
                "testname": vaccinename,
                "testdescription": description,
                "id": ID,
                "totalamount": labamount,
                "sgst": labsgst,
                "cgst": labcgst,
                "islab":"0",
            }
            showLoader()
            try {
              const response = await UpdateLabFee(input);
              if(response.output.isexists == 1){
                showErrorToast('Test name already exists for the same doctor');
                return false;
              }
              if(response){
                showSuccessToast('Vaccine Updated Successfully  ')
                editvaccineprice.current.closeRight();
                fetchVaccineList(pageno);
                    dismissLoader();
              }else{
                console.log("someting went wrong")
              }
              } catch (error) {
                console.log(error , " error in updating fee")
              }
           
        }
    }

    const openDeleteVaccineModal = (item) => {
      console.log('item: ', item)
      setLabID(item.id)
      setVaccineName(item.type)
      deletevaccineprice.current.openModal();
    };
    const deleteVaccine = async() => {
      showLoader();
            let input = {
                "doctorid":"",
                "testname": vaccinename,
                "id": ID,
                "islab":"1",
            }
            try {
              const response = await DeleteLabFee(input);
              // console.log(response.output.result == "success", " deleted respose ")
              if(response.output.result == "success"){
                // showErrorToast("Vaccine Deleted Successfully!")
                showSuccessToast("Vaccine Deleted Successfully!")
                deletevaccineprice.current.closeModal();
                fetchVaccineList();
                    dismissLoader();
              }else{
                console.log("someting went wrong")
              }
              } catch (error) {
                console.log(error , " error in updating fee")
              }
              dismissLoader();
    }

    const searchanythingvaccine = async (e) => {
         if (e.key === "Enter") {
          showLoader();
          try {
            setPageno(1);
             setPagesize(itemPerPageCommonValue);
             setCountFrom(1);
             setCountTo(itemPerPageCommonValue);
             setCurrentPage(1)

            const result = await GetLabList({
              "doctorid":"",
              "type": "vaccine",
              searchtext: searchtext,
              "pageno":"1",
              pagesize,
            });
            if (result != null) {
              setVaccineList(result.output.data);
              if (result && result.output.count === 0 && result.output.pagesize === 0) {
                setTotalPages(1);
              } else {
                setTotalPages(Math.ceil(result.output.count / result.output.pagesize));
              }
              //here
              
              setTotalItemCount(result.output.count)
              if (result.output.count < itemPerPageCommonValue) {
                setCountTo(result.output.count);
                setTotalExceedsPageCount(true);
              }else if(result.output.count > itemPerPageCommonValue && pageno == 1) {
                setCountTo(itemPerPageCommonValue);
                setTotalExceedsPageCount(false);
              }
            }else{
              setVaccineList(null)
              setTotalPages(1);
              dismissLoader();
            }
            dismissLoader();
          } catch (error) {
            console.error("Error in home:", error);
          }
         } 
      };
      const Filteranythingvaccine = async (e) => {
          showLoader();
          try {
             setPageno(1);
             setPagesize(itemPerPageCommonValue);
             setCountFrom(1);
             setCountTo(itemPerPageCommonValue);
             setCurrentPage(1)

            const result = await GetLabList({
              "doctorid":"",
              "type": "vaccine",
              searchtext: searchtext,
              "pageno":"1",
               pagesize,
            });
            if (result != null) {
              setVaccineList(result.output.data);
              if (result && result.output.count === 0 && result.output.pagesize === 0) {
                setTotalPages(1);
              } else {
                setTotalPages(Math.ceil(result.output.count / result.output.pagesize));
              }
              //here
              setTotalItemCount(result.output.count)
              if (result.output.count < itemPerPageCommonValue) {
                setCountTo(result.output.count);
                setTotalExceedsPageCount(true);
              }else if(result.output.count > itemPerPageCommonValue && pageno == 1) {
                setCountTo(itemPerPageCommonValue);
                setTotalExceedsPageCount(false);
              }
            }else{
              setVaccineList(null)
              setTotalPages(1);
              dismissLoader();
            }
            dismissLoader();
          } catch (error) {
            console.error("Error in home:", error);
          }
      };
      // const gobackfunction = ()=>{
      //   window.history.back();
      //  }
      const gobackfunctionvaccine = () => {
        if (window.history.length > 2 && location.key !== "default") {
          window.history.back();
      
          // Fallback if the page does not navigate
          setTimeout(() => {
            if (document.referrer === "" || window.history.length <= 1) {
              navigate("/home");
            }
          }, 500);
        } else {
          navigate("/home");
        }
      };
       const openaddmodalvaccine = ()=>{
        setVaccineName("");
        setLabCGST("");
        setLabSGST("");
        setLabAmount("");
        setDescription("")
        addvaccineprice.current.openRight()
       }

       const vaccineresetFields = () => {
        setCurrentPage(1);
        setPageno(1);

        //clear states for correct item count
        setPagesize(itemPerPageCommonValue);
        setCountFrom(1)
        setCountTo(itemPerPageCommonValue)
        
        fetchVaccineList(1)
      };

// ------------------------- procedure setup start ---------------------------
  // var [doctorid, setDoctorid] = useState(getLoginID());
  var [patientid, setPatientID] = useState("");
  var [procedurelist, setProcedureList] = useState(null);
  const [procedurename, setProcedureName] = useState("");
  const addprocedureprice = useRef();
  const editprocedureprice = useRef();
  const deleteprocedureprice = useRef();
  
  useEffect(() => {
    
  setActionAccess(actionAccessMain(12))
    fetchProcedureList(pageno);    
    const currency = getCurrency();
    if(currency == "USD"){
      const uscurrency = '$'
      setCurrency(uscurrency);
    }else{
    setCurrency(currency);
    }   
  }, [pageno]);
  const fetchProcedureList = async (page) => {
    setSerachText("");
  //  alert(countTo)
    showLoader()
    try {
        const result = await GetLabList({ 
          "doctorid":"",
          "type": "procedure",
          "pageno":page,
          pagesize
        });
        if (result != null) {
          setProcedureList(result.output.data);
          if (result && result.output.count === 0 && result.output.pagesize === 0) {
            setTotalPages(1);
          } else {
            setTotalPages(Math.ceil(result.output.count / result.output.pagesize));
          }
          
          setTotalItemCount(result.output.count)
          if (result.output.count < itemPerPageCommonValue) {
           // console.log("if bolock " ,result.output.count + " < " + itemPerPageCommonValue )
            setCountTo(result.output.count);
            setTotalExceedsPageCount(true);
          }else if(result.output.count > itemPerPageCommonValue && page == 1) {
            
          //  console.log("else bolock " ,result.output.count + " > " + itemPerPageCommonValue + " page - "+ page)
            setCountTo(itemPerPageCommonValue);
            setTotalExceedsPageCount(false);
          }
        }else{
          setProcedureList(null)
          setTotalPages(1);
          dismissLoader();
        }
        dismissLoader();
      } catch (error) {
        console.error("Error in home:", error);
      }
  };
  const handleProcedureNextClick = () => {
    // item count logic for next
    //here
   if(countTo + pagesize < totalItemCount){
    setCountTo(countTo + pagesize)
   }else{
     setCountTo(totalItemCount)
   }
   
   setCountFrom(countFrom + pagesize)

    setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
    fetchProcedureList(currentPage + 1);
    
      
   
  };

  const handleProcedurePreviousClick = () => {
      // item count logic for previous
     // setCurrentPage(currentPage - 1);
      
    //console.log(countTo +  " == " + totalItemCount + "| else count to -  " + pagesize)
      if(countTo == totalItemCount){
           //setCountTo(Math.floor(totalItemCount / 10) * 10)
         let updatedCountUnroundedValue  = totalItemCount - pagesize;
        setCountTo(Math.ceil(updatedCountUnroundedValue / itemPerPageCommonValue ) * itemPerPageCommonValue )
      }else{
        setCountTo(countTo - pagesize)
      }
      
      setCountFrom(countFrom - pagesize)

    setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
    fetchProcedureList(currentPage - 1);
     // alert(currentPage - 1)
  
  };
  const procedureTableHeader = [
    { key: "name", label: "Name" },
    { key: "sgst", label: "SGST" },
    { key: "cgst", label: "CGST" },
    { key: "amount", label: "Amount" },
    { key: "actions", label: "Actions" },

  ];
  const addProcedure = async() => {
    if(procedurename == ""){
      showErrorToast("Please specify the name");
      return false;
    }
    else if (labamount == "") {
         showErrorToast("Please specify the total amount");
         return false;
       }else if (labsgst == "") {
         showErrorToast("Please specify the sgst");
         return false;
       } else if (labcgst == "") {
           showErrorToast("Please specify the cgst");
           return false;
       }
       else {   
           let input = {
               "doctorid":"",
               "testname": procedurename,
               "testdescription": description,
               "totalamount": labamount,
               "sgst": labsgst,
               "cgst": labcgst,
               "islab":"0",
           }
           try {
             const response = await AddLabFee(input);
             if(response.output.message == "A Imaging Test with the same name already exists"){
              showErrorToast("Test name already exist")
             }else if(response){
              addimagingprice.current.closeRight();
               fetchProcedureList();
              dismissLoader();
             }else{
               console.log("someting went wrong")
             }
             } catch (error) {
               console.log(error , " error in updating fee")
             }
          
       }
   }
  const editProcedureDetailsSetState = (item) =>{
    setLabID(item.id)
    setLabAmount(item.totalamount);
    setLabSGST(item.sgst)
    setLabCGST(item.cgst)
    setProcedureName(item.type)
    setDescription(item.testdescription || "");

  }
  const openEditProcedureModal = (item) => {
    console.log('item Procedure: ', item)
    // editDetailsSetState(item)
    editProcedureDetailsSetState(item)
    editprocedureprice.current.openRight();
  };
    const editProceduretest = async() => {
      if(procedurename == ""){
        showErrorToast("Please specify the name");
        return false;
      }
     else if (labamount == "") {
          showErrorToast("Please specify the total amount");
          return false;
        }else if (labsgst == "") {
          showErrorToast("Please specify the sgst");
          return false;
        } else if (labcgst == "") {
            showErrorToast("Please specify the cgst");
            return false;
        }
        else {   
            let input = {
                "doctorid":"",
                "testname": procedurename,
                "testdescription": description,
                "id": ID,
                "totalamount": labamount,
                "sgst": labsgst,
                "cgst": labcgst,
                "islab":"0",
            }
            showLoader()
            try {
              const response = await UpdateLabFee(input);
              if(response.output.isexists == 1){
                showErrorToast('Test name already exists for the same doctor');
                return false;
              }
              if(response){
                showSuccessToast('Imaging Updated Successfully  ')
                editprocedureprice.current.closeRight();
                fetchProcedureList(pageno);
                    dismissLoader();
              }else{
                console.log("someting went wrong")
              }
              } catch (error) {
                console.log(error , " error in updating fee")
              }
           
        }
    }

    const openDeleteProcedureModal = (item) => {
      console.log('item: ', item)
      setLabID(item.id)
      setProcedureName(item.type)
      deleteprocedureprice.current.openModal();
    };
    const deleteProcedure = async() => {
      showLoader();
            let input = {
                "doctorid":"",
                "testname": procedurename,
                "id": ID,
                "islab":"1",
            }
            try {
              const response = await DeleteLabFee(input);
              // console.log(response.output.result == "success", " deleted respose ")
              if(response.output.result == "success"){
                // showErrorToast("Procedure Deleted Successfully!")
                showSuccessToast("Procedure Deleted Successfully!")
                deleteprocedureprice.current.closeModal();
                fetchProcedureList();
                    dismissLoader();
              }else{
                console.log("someting went wrong")
              }
              } catch (error) {
                console.log(error , " error in updating fee")
              }
              dismissLoader();
    }

    const searchanythingprocedure = async (e) => {
         if (e.key === "Enter") {
          showLoader();
          try {
            setPageno(1);
             setPagesize(itemPerPageCommonValue);
             setCountFrom(1);
             setCountTo(itemPerPageCommonValue);
             setCurrentPage(1)

            const result = await GetLabList({
              "doctorid":"",
              "type": "procedure",
              searchtext: searchtext,
              "pageno":"1",
              pagesize,
            });
            if (result != null) {
              setProcedureList(result.output.data);
              if (result && result.output.count === 0 && result.output.pagesize === 0) {
                setTotalPages(1);
              } else {
                setTotalPages(Math.ceil(result.output.count / result.output.pagesize));
              }
              //here
              
              setTotalItemCount(result.output.count)
              if (result.output.count < itemPerPageCommonValue) {
                setCountTo(result.output.count);
                setTotalExceedsPageCount(true);
              }else if(result.output.count > itemPerPageCommonValue && pageno == 1) {
                setCountTo(itemPerPageCommonValue);
                setTotalExceedsPageCount(false);
              }
            }else{
              setProcedureList(null)
              setTotalPages(1);
              dismissLoader();
            }
            dismissLoader();
          } catch (error) {
            console.error("Error in home:", error);
          }
         } 
      };
      const Filteranythingprocedure = async (e) => {
          showLoader();
          try {
             setPageno(1);
             setPagesize(itemPerPageCommonValue);
             setCountFrom(1);
             setCountTo(itemPerPageCommonValue);
             setCurrentPage(1)

            const result = await GetLabList({
              "doctorid":"",
              "type": "procedure",
              searchtext: searchtext,
              "pageno":"1",
               pagesize,
            });
            if (result != null) {
              setProcedureList(result.output.data);
              if (result && result.output.count === 0 && result.output.pagesize === 0) {
                setTotalPages(1);
              } else {
                setTotalPages(Math.ceil(result.output.count / result.output.pagesize));
              }
              //here
              setTotalItemCount(result.output.count)
              if (result.output.count < itemPerPageCommonValue) {
                setCountTo(result.output.count);
                setTotalExceedsPageCount(true);
              }else if(result.output.count > itemPerPageCommonValue && pageno == 1) {
                setCountTo(itemPerPageCommonValue);
                setTotalExceedsPageCount(false);
              }
            }else{
              setProcedureList(null)
              setTotalPages(1);
              dismissLoader();
            }
            dismissLoader();
          } catch (error) {
            console.error("Error in home:", error);
          }
      };
      // const gobackfunction = ()=>{
      //   window.history.back();
      //  }
      const gobackfunctionprocedure = () => {
        if (window.history.length > 2 && location.key !== "default") {
          window.history.back();
      
          // Fallback if the page does not navigate
          setTimeout(() => {
            if (document.referrer === "" || window.history.length <= 1) {
              navigate("/home");
            }
          }, 500);
        } else {
          navigate("/home");
        }
      };
       const openaddmodalprocedure = ()=>{
        setProcedureName("");
        setLabCGST("");
        setLabSGST("");
        setLabAmount("");
        setDescription("")
        addprocedureprice.current.openRight()
       }

       const procedureresetFields = () => {
        setCurrentPage(1);
        setPageno(1);

        //clear states for correct item count
        setPagesize(itemPerPageCommonValue);
        setCountFrom(1)
        setCountTo(itemPerPageCommonValue)
        
        fetchProcedureList(1)
      };

  return (
    <>
      <Global
        styles={css`
          .activeTab .whiteBorder::after {
            content: "";
            position: absolute;
            left: 0%;
            transform: translateX(-20%);
            transform: translateY(440%);
            border-radius: 5px 5px 0 0;
            top: 120%;
            background: #0b1f4f;
            height: 3px;
            width: 100%;
            z-index: 1;
          }

          .pendingVisits .swiper-container {
            height: 100%;
            max-height: 100vw;
            min-height: 0;
            min-width: 0;
            max-width: 100vw;
            width: 100%;
            overflow: hidden;
          }

          .pendingVisits .swiper-slide {
            width: 285px !important;
            flex-shrink: 0;
            display: block;
            height: 100%;
            max-height: 100%;
          }

          .pendingVisits .swiper {
            margin: 0 !important;
          }

          .pendingVisits .swiper-wrapper {
            max-height: 100%;
            height: 100%t;
            display: flex;
            gap: 20px;
            padding: 0 1rem;
          }
        `}
      />
      <Box w="100%">
        {isLoading && <Loader />}
        {screenType == "web" ? (
          <Flex>
            <Box w="6rem">
              <MiniSideBar />
            </Box>
            <Box w="calc(100vw - 6.5rem)">
              <SecondaryNav customHeader="Diagnostic Management" />

              {/* Main container start */}
              <Flex w="100%">
                <Box w="100%">
                  {/* Tab buttons start */}
                  <Box
                    display="flex"
                    gap="1rem"
                    borderBottom="1px solid #E6E7E9"
                    bg="white"
                    p="1.25rem 1.5rem"
                  >
                    <Box
                      as="button"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      pos="relative"
                      className={activeTab == "labsetup" ? "activeTab" : ""}
                      fontSize="0.87rem"
                      fontWeight="600"
                      onClick={() => tabChanged("labsetup")}
                      color={activeTab == "labsetup" ? "#061027" : "#898D97"}
                    >
                      <Text>Lab setup</Text>
                      <Box as="span" className="whiteBorder" />
                    </Box>
                    <Box
                      as="button"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      pos="relative"
                      className={activeTab == "imagingsetup" ? "activeTab" : ""}
                      fontSize="0.87rem"
                      fontWeight="600"
                      onClick={() => tabChanged("imagingsetup")}
                      color={activeTab == "imagingsetup" ? "#061027" : "#898D97"}
                    >
                      <Text>Imaging setup</Text>
                      <Box as="span" className="whiteBorder" />
                    </Box>
                    {/* <Box
                      as="button"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      pos="relative"
                      className={activeTab == "vaccinesetup" ? "activeTab" : ""}
                      fontSize="0.87rem"
                      fontWeight="600"
                      onClick={() => tabChanged("vaccinesetup")}
                      color={activeTab == "vaccinesetup" ? "#061027" : "#898D97"}
                    >
                      <Text>Vaccine setup</Text>
                      <Box as="span" className="whiteBorder" />
                    </Box>
                    <Box
                      as="button"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      pos="relative"
                      className={activeTab == "proceduresetup" ? "activeTab" : ""}
                      fontSize="0.87rem"
                      fontWeight="600"
                      onClick={() => tabChanged("proceduresetup")}
                      color={activeTab == "proceduresetup" ? "#061027" : "#898D97"}
                    >
                      <Text>Procedure setup</Text>
                      <Box as="span" className="whiteBorder" />
                    </Box> */}
                  </Box>
                  {/* Tab buttons end */}

                    {/* Lab setup Tab */}
                    {activeTab == "labsetup" && (
                      <>
                        <Box w="100%">
            <Box
              gap="10px"
              my="1rem"
              px="1rem"
              w="100%"
              display="flex"
              flexDirection="row"
              justifyContent="center"
              alignItems="center"
            >
            <Box w="100%" display="flex" justifyContent='space-between'>
              <Flex w='100%' gap='1rem'>
              <PrimaryInput
                  variant="fullRound"
                  inputPlace="Search"
                  // inputStyleCss={{h: "40px"}}
                  onKeyPress={searchanything}
                  maxLength={50}
                  onChange={(e) => setSerachText(e.target.value)}
                  inputValue={searchtext}
                />
                 <PrimaryButton
                  buttonText="Filter"
                  id="filterButton"
                  variant="mdBtn"
                  btnStyle={{w: "80px"}}
                  onClick={Filteranything}
                />
                 <PrimaryButton
                  buttonText="Reset"
                  id="resetButton"
                  variant="grayBtn"
                  btnStyle={{ color: "#AA2F27" }}
                  // onClick={()=>fetchLabList(1)}
                  onClick={resetFields}

                />
                 <PrimaryButton
                  buttonText="Add"
                  id="filterButton"
                  variant="mdBtn"
                  btnStyle={{w: "80px"}}
                  onClick={openaddmodal}
                  isDisabled={
                    actionAccess && !actionAccess.create
                      ? true
                      : false
                  }
                />
              </Flex>
            </Box>
            </Box>
            <Divider />
            {lablist && lablist.length > 0 ? (
                       <Box>
                       <Flex
                         w="100%"
                         flexDir="column"
                         gap="1rem"
                         p="1rem"
                         h="calc(100vh - 70px)"
                       >
                            <SimpleTable
                              headers={TableHeader}
                              isDataPresent={true}
                              ThStyle={{
                                bg: "#FAFAFA",
                              }}
                              footerStyle={{
                                pos: "fixed",
                                bottom: "0px",
                                boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
                                zIndex:'999',
                                w:"100%"
                              }}
                              tableStyle={{
                                minH: "calc(100vh - 240px)",
                                maxH: "calc(100vh - 240px)",
                                overflowY: "auto",
                                tableLayout: "fixed",
                                width: "100%",
                                border: "1px solid #E6E7E9",
                              }}
                              tableBody={
                                <>
                                  {lablist &&
                                    lablist.map((step, index) => (
                                      <Tr w="100%" key={index}>
                                        <Td w="100x">
                                        <Text fontSize=".875rem" fontWeight="500">
                                            {step.type? step.type:""}
                                          </Text>
                                        </Td>

                                        <Td>
                                          <Text fontSize=".875rem" fontWeight="500">
                                            {step.sgst || step.sgst == 0 ? step.sgst+"%":"-"}
                                            {/* {step.sgst ? step.sgst+"%":"-"} */}
                                          </Text>
                                        </Td>

                                        <Td>
                                          
                                            <Text
                                              fontSize=".875rem"
                                              fontWeight="500"
                                              //color="#109E6A"
                                            >
                                              {step.cgst || step.cgst == 0 ? step.cgst+"%": '-'}
                                              {/* {step.cgst ? step.cgst+"%": '-'} */}
                                            </Text>
                                        </Td>

                                        <Td>
                                          <Text fontSize=".875rem" fontWeight="500">
                                          {step.totalamount? currency+" " + formatToDecimal(step.totalamount):"0"}
                                          </Text>
                                        </Td>
                                        <Td pos='relative'>
                              <Menu isLazy>
                                <MenuButton as="button" zIndex={1}>
                                  <Image
                                    w="1.5rem"
                                    src="/assets/svgs/more-options.svg"
                                  />
                                </MenuButton>
                                <MenuList
                                  zIndex={2}
                                  pos="relative"
                                  right="100px"
                                  minW="125px"
                                >
                                  <MenuItem onClick={() => openEditModal(step)}
                                  isDisabled={ actionAccess && (!actionAccess.update) ? true : false} >
                                    Edit
                                  </MenuItem>
                                  <MenuItem onClick={() => openDeleteModal(step)}
                                  isDisabled={ actionAccess && (!actionAccess.delete) ? true : false} >
                                    Delete
                                  </MenuItem>
                                 </MenuList>
                              </Menu>
                            </Td>
                                       
                                      </Tr>
                                    ))}
                                </>
                              }
                              footerSection={
                                <>
                                  <Tr w='100%'>
                                    <Td colSpan={8} width='calc(100vw - 6.5rem)'>
                                      <Box
                                        w="100%"
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems="center"
                                      >
                                         <Box 
                                      visibility={(totalItemCount < countTo && !totalExceedsPageCount)  ? "hidden" : "visible"}
                                      >
                                         <Text>Showing  <b>{countFrom}</b> to <b>{countTo}</b>  of {totalItemCount} results</Text>
                                         </Box>
             
             
                                       <Box  
                                       gap="2.5rem"
                                        display="flex"
                                       justifyContent="space-between"
                                       alignItems="center" >
                                        <Box as="button" onClick={handlePreviousClick} disabled={currentPage === 1} visibility={currentPage === 1 ? 'hidden' : 'visible'} p="0.5rem 0.75rem" border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" fontSize="1rem" fontWeight="500">
                                            Previous
                                          </Box>
                                        <Box>
                                          <Text textAlign="center" fontSize=".875rem" fontWeight="600">
                                          Page {currentPage} of {totalPages}
                                          </Text>
                                        </Box>
                                        {(totalItemCount >= countTo && !totalExceedsPageCount)  && 
                                          <Box as="button" p="0.5rem 0.75rem" mr='2.5rem' border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" onClick={handleNextClick} 
                                          disabled={currentPage === totalPages} 
                                          visibility={currentPage === totalPages ? 'hidden' : 'visible'} 
                                          fontSize="1rem" fontWeight="500">
                                            Next
                                          </Box>
                                        }
                                      </Box>
                                      </Box>
                                    </Td>
                                  </Tr>
                                </>
                              }
                            />
                          </Flex>
                          </Box>
                      ) : (
                        <SimpleTable
                          headers={TableHeader}
                          // isDataPresent={false}
                        />
                      )}
          </Box>
                        {/* Table end */}
                      </>
                    )}

                  {/* Imaging setup Tab */}
                  {activeTab == "imagingsetup" && (
                    <>
                      <Box w="100%">
            {/* <SecondaryNav withBack="Imaging Setup" goBack={gobackfunction} /> */}
            <Box
              gap="10px"
              my="1rem"
              px="1rem"
              w="100%"
              display="flex"
              flexDirection="row"
              justifyContent="center"
              alignItems="center"
            >
            <Box w="100%" display="flex" justifyContent='space-between'>
              <Flex w='100%' gap='1rem'>
              <PrimaryInput
                  variant="fullRound"
                  inputPlace="Search"
                  // inputStyleCss={{h: "40px"}}
                  onKeyPress={searchanythingimaging}
                  maxLength={50}
                  onChange={(e) => setSerachText(e.target.value)}
                  inputValue={searchtext}
                />
                 <PrimaryButton
                  buttonText="Filter"
                  id="filterButton"
                  variant="mdBtn"
                  btnStyle={{w: "80px"}}
                  onClick={Filteranythingimaging}
                />
                 <PrimaryButton
                  buttonText="Reset"
                  id="resetButton"
                  variant="grayBtn"
                  btnStyle={{ color: "#AA2F27" }}
                  onClick={imagingresetFields}
                />
                 <PrimaryButton
                  buttonText="Add"
                  id="filterButton"
                  variant="mdBtn"
                  btnStyle={{w: "80px"}}
                  onClick={openaddmodalimaging}
                  isDisabled={
                    actionAccess && !actionAccess.create
                      ? true
                      : false
                  }
                />
              </Flex>
            </Box>
            </Box>
            <Divider />
            {imaginglist && imaginglist.length > 0 ? (
                       <Box>
                       <Flex
                         w="100%"
                         flexDir="column"
                         gap="1rem"
                        //  p="1rem"
                         h="calc(100vh - 70px)"
                       >
                            <SimpleTable
                              headers={imagingTableHeader}
                              isDataPresent={true}
                              ThStyle={{
                                bg: "#FAFAFA",
                              }}
                              footerStyle={{
                                pos: "fixed",
                                bottom: "0px",
                                w:"100%",
                                zIndex: "99",
                                boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
                              }}
                              tableStyle={{
                                maxH: "calc(100vh - 250px)",
                                overflowY: "auto",
                                tableLayout: "fixed",
                                width: "100%",
                                border: "1px solid #E6E7E9",
                                h: "100%"
                              }}
                              tableBody={
                                <>
                                  {imaginglist &&
                                    imaginglist.map((step, index) => (
                                      <Tr w="100%" key={index}>
                                        <Td w="100x">
                                        <Text fontSize=".875rem" fontWeight="500">
                                            {step.type? step.type:""}
                                          </Text>
                                        </Td>

                                        <Td>
                                          <Text fontSize=".875rem" fontWeight="500">
                                            {step.sgst || step.sgst == 0 ? step.sgst+"%":""}
                                          </Text>
                                        </Td>

                                        <Td>
                                          
                                            <Text
                                              fontSize=".875rem"
                                              fontWeight="500"
                                              //color="#109E6A"
                                            >
                                              {step.cgst || step.cgst == 0 ? step.cgst+"%": '-'}
                                            </Text>
                                        </Td>

                                        <Td>
                                          <Text fontSize=".875rem" fontWeight="500">
                                          {step.totalamount? currency+" " + formatToDecimal(step.totalamount):"0"}
                                          </Text>
                                        </Td>
                                        <Td pos='relative'>
                              <Menu isLazy>
                                <MenuButton as="button" zIndex={1}>
                                  <Image
                                    w="1.5rem"
                                    src="/assets/svgs/more-options.svg"
                                  />
                                </MenuButton>
                                <MenuList
                                  zIndex={9}
                                  pos="relative"
                                  right="100px"
                                  minW="125px"
                                >
                                  <MenuItem onClick={() => openEditImagingModal(step)}
                                  isDisabled={ actionAccess && (!actionAccess.update) ? true : false} >
                                    Edit
                                  </MenuItem>
                                  <MenuItem onClick={() => openDeleteImagingModal(step)}
                                  isDisabled={ actionAccess && (!actionAccess.delete) ? true : false} >
                                    Delete
                                  </MenuItem>
                                 </MenuList>
                              </Menu>
                            </Td>
                                       
                                      </Tr>
                                    ))}
                                </>
                              }
                              footerSection={
                                <>
                                  <Tr w='100%'>
                                    <Td colSpan={8} width='calc(100vw - 6.5rem)'>
                                      <Box
                                        w="100%"
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems="center"
                                      >
                                         <Box 
                                      visibility={(totalItemCount < countTo && !totalExceedsPageCount)  ? "hidden" : "visible"}
                                      >
                                         <Text>Showing  <b>{countFrom}</b> to <b>{countTo}</b>  of {totalItemCount} results</Text>
                                         </Box>
             
             
                                       <Box  
                                       gap="2.5rem"
                                        display="flex"
                                       justifyContent="space-between"
                                       alignItems="center" >
                                        <Box as="button" onClick={handleImagingPreviousClick} disabled={currentPage === 1} visibility={currentPage === 1 ? 'hidden' : 'visible'} p="0.5rem 0.75rem" border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" fontSize="1rem" fontWeight="500">
                                            Previous
                                          </Box>
                                        <Box>
                                          <Text textAlign="center" fontSize=".875rem" fontWeight="600">
                                          Page {currentPage} of {totalPages}
                                          </Text>
                                        </Box>
                                        {(totalItemCount >= countTo && !totalExceedsPageCount)  && 
                                          <Box as="button" p="0.5rem 0.75rem" mr='2.5rem' border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" onClick={handleImagingNextClick} 
                                          disabled={currentPage === totalPages} 
                                          visibility={currentPage === totalPages ? 'hidden' : 'visible'} 
                                          fontSize="1rem" fontWeight="500">
                                            Next
                                          </Box>
                                        }
                                      </Box>
                                      </Box>
                                    </Td>
                                  </Tr>
                                </>
                              }
                            />
                          </Flex>
                          </Box>
                      ) : (
                        <SimpleTable
                          headers={imagingTableHeader}
                          // isDataPresent={false}
                        />
                      )}
          </Box>
                      {/* Table end */}
                    </>
                  )}

                  {/* Vaccine setup Tab */}
                  {activeTab == "vaccinesetup" && (
                    <>
                      <Box w="100%">
            {/* <SecondaryNav withBack="Imaging Setup" goBack={gobackfunction} /> */}
            <Box
              gap="10px"
              my="1rem"
              px="1rem"
              w="100%"
              display="flex"
              flexDirection="row"
              justifyContent="center"
              alignItems="center"
            >
            <Box w="100%" display="flex" justifyContent='space-between'>
              <Flex w='100%' gap='1rem'>
              <PrimaryInput
                  variant="fullRound"
                  inputPlace="Search"
                  // inputStyleCss={{h: "40px"}}
                  onKeyPress={searchanythingvaccine}
                  maxLength={50}
                  onChange={(e) => setSerachText(e.target.value)}
                  inputValue={searchtext}
                />
                 <PrimaryButton
                  buttonText="Filter"
                  id="filterButton"
                  variant="mdBtn"
                  btnStyle={{w: "80px"}}
                  onClick={Filteranythingvaccine}
                />
                 <PrimaryButton
                  buttonText="Reset"
                  id="resetButton"
                  variant="grayBtn"
                  btnStyle={{ color: "#AA2F27" }}
                  onClick={vaccineresetFields}
                />
                 <PrimaryButton
                  buttonText="Add"
                  id="filterButton"
                  variant="mdBtn"
                  btnStyle={{w: "80px"}}
                  onClick={openaddmodalvaccine}
                  isDisabled={
                    actionAccess && !actionAccess.create
                      ? true
                      : false
                  }
                />
              </Flex>
            </Box>
            </Box>
            <Divider />
            {vaccinelist && vaccinelist.length > 0 ? (
                       <Box>
                       <Flex
                         w="100%"
                         flexDir="column"
                         gap="1rem"
                        //  p="1rem"
                         h="calc(100vh - 70px)"
                       >
                            <SimpleTable
                              headers={vaccineTableHeader}
                              isDataPresent={true}
                              ThStyle={{
                                bg: "#FAFAFA",
                              }}
                              footerStyle={{
                                pos: "fixed",
                                bottom: "0px",
                                w:"100%",
                                zIndex: "99",
                                boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
                              }}
                              tableStyle={{
                                maxH: "calc(100vh - 250px)",
                                overflowY: "auto",
                                tableLayout: "fixed",
                                width: "100%",
                                border: "1px solid #E6E7E9",
                                h: "100%"
                              }}
                              tableBody={
                                <>
                                  {vaccinelist &&
                                    vaccinelist.map((step, index) => (
                                      <Tr w="100%" key={index}>
                                        <Td w="100x">
                                        <Text fontSize=".875rem" fontWeight="500">
                                            {step.type? step.type:""}
                                          </Text>
                                        </Td>

                                        <Td>
                                          <Text fontSize=".875rem" fontWeight="500">
                                            {step.sgst || step.sgst == 0 ? step.sgst+"%":""}
                                          </Text>
                                        </Td>

                                        <Td>
                                          
                                            <Text
                                              fontSize=".875rem"
                                              fontWeight="500"
                                              //color="#109E6A"
                                            >
                                              {step.cgst || step.cgst == 0 ? step.cgst+"%": '-'}
                                            </Text>
                                        </Td>

                                        <Td>
                                          <Text fontSize=".875rem" fontWeight="500">
                                          {step.totalamount? currency+" " + formatToDecimal(step.totalamount):"0"}
                                          </Text>
                                        </Td>
                                        <Td pos='relative'>
                              <Menu isLazy>
                                <MenuButton as="button" zIndex={1}>
                                  <Image
                                    w="1.5rem"
                                    src="/assets/svgs/more-options.svg"
                                  />
                                </MenuButton>
                                <MenuList
                                  zIndex={9}
                                  pos="relative"
                                  right="100px"
                                  minW="125px"
                                >
                                  <MenuItem onClick={() => openEditVaccineModal(step)}
                                  isDisabled={ actionAccess && (!actionAccess.update) ? true : false} >
                                    Edit
                                  </MenuItem>
                                  <MenuItem onClick={() => openDeleteVaccineModal(step)}
                                  isDisabled={ actionAccess && (!actionAccess.delete) ? true : false} >
                                    Delete
                                  </MenuItem>
                                 </MenuList>
                              </Menu>
                            </Td>
                                       
                                      </Tr>
                                    ))}
                                </>
                              }
                              footerSection={
                                <>
                                  <Tr w='100%'>
                                    <Td colSpan={8} width='calc(100vw - 6.5rem)'>
                                      <Box
                                        w="100%"
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems="center"
                                      >
                                         <Box 
                                      visibility={(totalItemCount < countTo && !totalExceedsPageCount)  ? "hidden" : "visible"}
                                      >
                                         <Text>Showing  <b>{countFrom}</b> to <b>{countTo}</b>  of {totalItemCount} results</Text>
                                         </Box>
             
             
                                       <Box  
                                       gap="2.5rem"
                                        display="flex"
                                       justifyContent="space-between"
                                       alignItems="center" >
                                        <Box as="button" onClick={handleVaccinePreviousClick} disabled={currentPage === 1} visibility={currentPage === 1 ? 'hidden' : 'visible'} p="0.5rem 0.75rem" border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" fontSize="1rem" fontWeight="500">
                                            Previous
                                          </Box>
                                        <Box>
                                          <Text textAlign="center" fontSize=".875rem" fontWeight="600">
                                          Page {currentPage} of {totalPages}
                                          </Text>
                                        </Box>
                                        {(totalItemCount >= countTo && !totalExceedsPageCount)  && 
                                          <Box as="button" p="0.5rem 0.75rem" mr='2.5rem' border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" onClick={handleVaccineNextClick} 
                                          disabled={currentPage === totalPages} 
                                          visibility={currentPage === totalPages ? 'hidden' : 'visible'} 
                                          fontSize="1rem" fontWeight="500">
                                            Next
                                          </Box>
                                        }
                                      </Box>
                                      </Box>
                                    </Td>
                                  </Tr>
                                </>
                              }
                            />
                          </Flex>
                          </Box>
                      ) : (
                        <SimpleTable
                          headers={vaccineTableHeader}
                          // isDataPresent={false}
                        />
                      )}
          </Box>
                      {/* Table end */}
                    </>
                  )}

                  {/* Procedure setup Tab */}
                  {activeTab == "proceduresetup" && (
                    <>
                      <Box w="100%">
            {/* <SecondaryNav withBack="Imaging Setup" goBack={gobackfunction} /> */}
            <Box
              gap="10px"
              my="1rem"
              px="1rem"
              w="100%"
              display="flex"
              flexDirection="row"
              justifyContent="center"
              alignItems="center"
            >
            <Box w="100%" display="flex" justifyContent='space-between'>
              <Flex w='100%' gap='1rem'>
              <PrimaryInput
                  variant="fullRound"
                  inputPlace="Search"
                  // inputStyleCss={{h: "40px"}}
                  onKeyPress={searchanythingprocedure}
                  maxLength={50}
                  onChange={(e) => setSerachText(e.target.value)}
                  inputValue={searchtext}
                />
                 <PrimaryButton
                  buttonText="Filter"
                  id="filterButton"
                  variant="mdBtn"
                  btnStyle={{w: "80px"}}
                  onClick={Filteranythingprocedure}
                />
                 <PrimaryButton
                  buttonText="Reset"
                  id="resetButton"
                  variant="grayBtn"
                  btnStyle={{ color: "#AA2F27" }}
                  onClick={procedureresetFields}
                />
                 <PrimaryButton
                  buttonText="Add"
                  id="filterButton"
                  variant="mdBtn"
                  btnStyle={{w: "80px"}}
                  onClick={openaddmodalprocedure}
                  isDisabled={
                    actionAccess && !actionAccess.create
                      ? true
                      : false
                  }
                />
              </Flex>
            </Box>
            </Box>
            <Divider />
            {procedurelist && procedurelist.length > 0 ? (
                       <Box>
                       <Flex
                         w="100%"
                         flexDir="column"
                         gap="1rem"
                        //  p="1rem"
                         h="calc(100vh - 70px)"
                       >
                            <SimpleTable
                              headers={procedureTableHeader}
                              isDataPresent={true}
                              ThStyle={{
                                bg: "#FAFAFA",
                              }}
                              footerStyle={{
                                pos: "fixed",
                                bottom: "0px",
                                w:"100%",
                                zIndex: "99",
                                boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
                              }}
                              tableStyle={{
                                maxH: "calc(100vh - 250px)",
                                overflowY: "auto",
                                tableLayout: "fixed",
                                width: "100%",
                                border: "1px solid #E6E7E9",
                                h: "100%"
                              }}
                              tableBody={
                                <>
                                  {procedurelist &&
                                    procedurelist.map((step, index) => (
                                      <Tr w="100%" key={index}>
                                        <Td w="100x">
                                        <Text fontSize=".875rem" fontWeight="500">
                                            {step.type? step.type:""}
                                          </Text>
                                        </Td>

                                        <Td>
                                          <Text fontSize=".875rem" fontWeight="500">
                                            {step.sgst || step.sgst == 0 ? step.sgst+"%":""}
                                          </Text>
                                        </Td>

                                        <Td>
                                          
                                            <Text
                                              fontSize=".875rem"
                                              fontWeight="500"
                                              //color="#109E6A"
                                            >
                                              {step.cgst || step.cgst == 0 ? step.cgst+"%": '-'}
                                            </Text>
                                        </Td>

                                        <Td>
                                          <Text fontSize=".875rem" fontWeight="500">
                                          {step.totalamount? currency+" " + formatToDecimal(step.totalamount):"0"}
                                          </Text>
                                        </Td>
                                        <Td pos='relative'>
                              <Menu isLazy>
                                <MenuButton as="button" zIndex={1}>
                                  <Image
                                    w="1.5rem"
                                    src="/assets/svgs/more-options.svg"
                                  />
                                </MenuButton>
                                <MenuList
                                  zIndex={9}
                                  pos="relative"
                                  right="100px"
                                  minW="125px"
                                >
                                  <MenuItem onClick={() => openEditProcedureModal(step)}
                                  isDisabled={ actionAccess && (!actionAccess.update) ? true : false} >
                                    Edit
                                  </MenuItem>
                                  <MenuItem onClick={() => openDeleteProcedureModal(step)}
                                  isDisabled={ actionAccess && (!actionAccess.delete) ? true : false} >
                                    Delete
                                  </MenuItem>
                                 </MenuList>
                              </Menu>
                            </Td>
                                       
                                      </Tr>
                                    ))}
                                </>
                              }
                              footerSection={
                                <>
                                  <Tr w='100%'>
                                    <Td colSpan={8} width='calc(100vw - 6.5rem)'>
                                      <Box
                                        w="100%"
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems="center"
                                      >
                                         <Box 
                                      visibility={(totalItemCount < countTo && !totalExceedsPageCount)  ? "hidden" : "visible"}
                                      >
                                         <Text>Showing  <b>{countFrom}</b> to <b>{countTo}</b>  of {totalItemCount} results</Text>
                                         </Box>
             
             
                                       <Box  
                                       gap="2.5rem"
                                        display="flex"
                                       justifyContent="space-between"
                                       alignItems="center" >
                                        <Box as="button" onClick={handleProcedurePreviousClick} disabled={currentPage === 1} visibility={currentPage === 1 ? 'hidden' : 'visible'} p="0.5rem 0.75rem" border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" fontSize="1rem" fontWeight="500">
                                            Previous
                                          </Box>
                                        <Box>
                                          <Text textAlign="center" fontSize=".875rem" fontWeight="600">
                                          Page {currentPage} of {totalPages}
                                          </Text>
                                        </Box>
                                        {(totalItemCount >= countTo && !totalExceedsPageCount)  && 
                                          <Box as="button" p="0.5rem 0.75rem" mr='2.5rem' border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" onClick={handleProcedureNextClick} 
                                          disabled={currentPage === totalPages} 
                                          visibility={currentPage === totalPages ? 'hidden' : 'visible'} 
                                          fontSize="1rem" fontWeight="500">
                                            Next
                                          </Box>
                                        }
                                      </Box>
                                      </Box>
                                    </Td>
                                  </Tr>
                                </>
                              }
                            />
                          </Flex>
                          </Box>
                      ) : (
                        <SimpleTable
                          headers={procedureTableHeader}
                          // isDataPresent={false}
                        />
                      )}
          </Box>
                      {/* Table end */}
                    </>
                  )}
                </Box>
              </Flex>
            </Box>
          </Flex>
        ) : (
          <>
            <MobileNavbar />
            <MobileSecondaryNav header='Orders' handlebackarrow={() => navigate('/home')} />
            {/* Tab buttons start */}
            <Box
              display="flex"
              gap="1rem"
              borderBottom="1px solid #E6E7E9"
              bg="white"
              p="1.25rem 1.5rem"
              overflow='scroll hidden'
            >
              <Box
                as="button"
                display="flex"
                justifyContent="center"
                alignItems="center"
                pos="relative"
                className={activeTab == "labs" ? "activeTab" : ""}
                fontSize="0.87rem"
                fontWeight="600"
                onClick={() => tabChanged("labs")}
                color={activeTab == "labs" ? "#061027" : "#898D97"}
              >
                <Text>Labs</Text>
                <Box as="span" className="whiteBorder" />
              </Box>
              <Box
                as="button"
                display="flex"
                justifyContent="center"
                alignItems="center"
                pos="relative"
                className={activeTab == "imaging" ? "activeTab" : ""}
                fontSize="0.87rem"
                fontWeight="600"
                onClick={() => tabChanged("imaging")}
                color={activeTab == "imaging" ? "#061027" : "#898D97"}
              >
                <Text>Imaging</Text>
                <Box as="span" className="whiteBorder" />
              </Box>
            </Box>
            {/* Tab buttons end */}


          </>
        )}
      </Box>

{/* ---------------------- new modals for lab setup ----------------------------- */}
<ModalRight
        ref={addlabprice}
        header="Add Test"
        modalWidth={{ base: "100%", lg: "calc(100vw - 50%)" }}
        body={
          <>
            <Box w="100%" mt="1rem">
              <Box w="100%" display="flex">
              <PrimaryInput
                  variant="leftSide"
                  inputPlace="Test Name*"
                  onChange={(e) => {
                    const value = e.target.value;
                    // Allow only digits (no decimals, no characters)
                    if (/^[a-zA-Z0-9.'-\s]*$/.test(value)) {
                      setLabName(value);
                    }
                  }}
                   inputValue={labname}
                   defaultValue={labname}
                   maxLength={60}
                />
                 {/* <PrimaryInput
                  variant="rightSide"
                  inputPlace="Description"
                  onChange={(e) => {
                    const value = e.target.value;
                    // Allow only digits (no decimals, no characters)
                    // if (/^[a-zA-Z\s]*$/.test(value)) {
                      if (value) {
                      setDescription(value);
                    }
                  }}
                   inputValue={description}
                   defaultValue={description}
                   maxLength={200}
                /> */}
                <PrimaryInput
                  variant="rightSide"
                  inputPlace={"Amount* (" + (currency)+")"}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Allow only digits (no decimals, no characters)
                    if (/^\d*\.?\d*$/.test(value)) {
                      setLabAmount(value);
                    }
                  }}
                   inputValue={labamount}
                   defaultValue={labamount}
                   maxLength={7}
                />                
               
              </Box>
              {/* <Box w="100%" display="flex">
              <PrimaryInput
                  variant="leftDown"
                  inputPlace={"Amount* (" + (currency)+")"}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Allow only digits (no decimals, no characters)
                    if (/^\d*\.?\d*$/.test(value)) {
                      setLabAmount(value);
                    }
                  }}
                   inputValue={labamount}
                   defaultValue={labamount}
                   maxLength={7}
                />
                </Box> */}
              <Box w="100%" display="flex">
                <PrimaryInput
                  variant="leftDown"
                  inputPlace="SGST* %"
                  onChange={(e) => {
                    const value = e.target.value;
                    // Allow only digits (no decimals, no characters)
                    if (/^\d*$/.test(value)) {
                      setLabSGST(value);
                    }
                  }}
                   inputValue={labsgst}
                   defaultValue={labsgst}
                   maxLength={3}
                />
                <PrimaryInput
                  variant="rightDown"
                  inputPlace="CGST* %"
                  onChange={(e) => {
                    const value = e.target.value;
                    // Allow only digits (no decimals, no characters)
                    if (/^\d*$/.test(value)) {
                      setLabCGST(value);
                    }
                  }}
                   inputValue={labcgst}
                   defaultValue={labcgst}
                   maxLength={6}
                />
              </Box>

              {/* Add Metrics Button */}
  <Box w="100%" mt="1rem">
    <PrimaryButton
      buttonText={showMetricsTable ? "Hide Metrics" : "Add Metrics"}
      variant={showMetricsTable ? "grayBtnFull" : "blueBtnFull"}
      onClick={toggleMetricsTable}
      btnStyle={{ width: "150px" }}
    />
  </Box>

               {/* Metrics Table - Conditionally Rendered */}
              {showMetricsTable && (
                <Box w="100%" display="flex" mt='2rem'>
                  <SimpleTableLabs
                    NoDataHeader={false}
                    isDataPresent={true}
                    ThStyle={{ textAlign: "center", bg: "#FAFAFA" }}
                    tableStyle={{
                      h: "calc(100vh - 170px)",
                      maxH: "calc(100vh - 170px)",
                      overflowY: "auto",
                      overflowX: "auto",
                      width: "100%",
                      border: "1px solid #E6E7E9",
                      borderBottom: "none",
                    }}
                    tableHeaders={
                      <Tr bg='white' zIndex='9999' pos='relative'>
                        <Th fontSize="0.87rem" fontWeight="500" pl="10px">
                          Metric name
                        </Th>
                        <Th fontSize="0.87rem" fontWeight="500" pl="10px">
                          Unit
                        </Th>
                        <Th fontSize="0.87rem" fontWeight="500" pl="10px">
                          Low Range
                        </Th>
                        <Th fontSize="0.87rem" fontWeight="500" pl="10px">
                          High Range
                        </Th>
                        <Th fontSize="0.87rem" fontWeight="500" pl="10px">
                          Formula
                        </Th>
                        <Th fontSize="0.87rem" fontWeight="500">
                          <Flex w="100%" justifyContent="center" alignItems="center">
                            <PrimaryButton
                              btnIcon="/assets/svgs/add-white.svg"
                              iconSrc={true}
                              btnStyle={{ w: "25px", h: "25px", p: "0", m: "0" }}
                              iconSrcStyle={{ mr: "0", w: "10px" }}
                              onClick={AddAnotherRowLabTest}
                            />
                          </Flex>
                        </Th>
                      </Tr>
                    }
                    tableBody={
                      <>
                        {rows?.map((row, index) => (
                          <Tr w="100%" key={index}>
                            <Td p="0">
                              <Box w="100%" pos="relative" cursor="pointer">
                                <PrimaryInput
                                  variant="bothSide"
                                  inputPlace="Metric name"
                                  inputValue={row.metricname}
                                  id={index === rows.length - 1 ? "LabNameInAdd" : ""}
                                  onChange={(e) =>
                                    handleMetricNameChange(e.target.value, index)
                                  }
                                  autocomplete="off"
                                  inputCssStyle={{
                                    _hover: {
                                      border: "1px solid",
                                      borderRadius: "10px",
                                    },
                                  }}
                                  maxLength={100}
                                />
                              </Box>
                            </Td>
                            <Td p="0">
                              <PrimaryInput
                                variant="bothSide"
                                inputPlace='Unit'
                                inputValue={row.unit}
                                onChange={(e) =>
                                  handleUnitChange(e.target.value, index)
                                }
                                maxLength={10}
                                inputCssStyle={{
                                  _hover: { border: "1px solid", borderRadius: "10px" },
                                }}
                              />
                            </Td>
                            <Td p="0">
                              <PrimaryInput
                                variant="bothSide"
                                inputPlace="Low Range"
                                inputValue={row.lowrange}
                                onChange={(e) =>
                                  handleLowRangeChange(e.target.value, index)
                                }
                                inputCssStyle={{
                                  _hover: { border: "1px solid", borderRadius: "10px" },
                                }}
                                maxLength={30}
                              />
                            </Td>
                            <Td p="0">
                              <PrimaryInput
                                variant="bothSide"
                                inputPlace="High Range"
                                inputValue={row.highrange}
                                onChange={(e) =>
                                  handleHighRangeChange(e.target.value, index)
                                }
                                inputCssStyle={{
                                  _hover: { border: "1px solid", borderRadius: "10px" },
                                }}
                                maxLength={30}
                              />
                            </Td>
                            <Td p="0">
                              <PrimaryInput
                                variant="bothSide"
                                inputPlace="Formula"
                                inputValue={row.formula}
                                onChange={(e) =>
                                  handleFormulaChange(e.target.value, index)
                                }
                                inputCssStyle={{
                                  _hover: { border: "1px solid", borderRadius: "10px" },
                                }}
                                maxLength={30}
                              />
                            </Td>
                            <Td p="0">
                              <Box
                                as="button"
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                w="100%"
                                onClick={() => confirmDeleteRow(index)}
                              >
                                <Image src="/assets/svgs/delete.svg" opacity="0.7" />
                              </Box>
                            </Td>
                          </Tr>
                        ))}
                      </>
                    }
                  />
                </Box>
              )}
            </Box>
          </>
        }
        footerActions={
          <>
            <Box w="100%" display="flex" gap="1rem">
              <PrimaryButton
                buttonText="Cancel"
                variant="grayBtnFull"
                btnStyle={{ color: "#AA2F27" }}
                
                onClick={() => addlabprice.current.closeRight()}
              />

              <PrimaryButton
                buttonText="Save"
                onClick={() => addLabtest()}
              />
            </Box>
          </>
        }
      />
      <ModalRight
        ref={editlabprice}
        header="Edit Lab Pricing"
        modalWidth={{ base: "100%", lg: "calc(100vw - 50%)" }}
        body={
          <>
            <Box w="100%" mt="1rem">
            <Box w="100%" display="flex">
              <PrimaryInput
                  variant="leftSide"
                  inputPlace="Test Name*"
                  onChange={(e) => {
                    const value = e.target.value;
                    // Allow only digits (no decimals, no characters)
                    if (/^[a-zA-Z0-9.'-\s]*$/.test(value)) {
                      setLabName(value);
                    }
                  }}
                   inputValue={labname}
                   defaultValue={labname}
                   maxLength={60}
                />
                 {/* <PrimaryInput
                  variant="rightSide"
                  inputPlace="Description"
                  onChange={(e) => {
                    const value = e.target.value;
                    // Allow only digits (no decimals, no characters)
                    // if (/^[a-zA-Z\s]*$/.test(value)) {
                      if (value) {
                      setDescription(value);
                    }
                  }}
                   inputValue={description}
                   defaultValue={description}
                   maxLength={200}
                /> */}
                <PrimaryInput
                  variant="rightSide"
                  inputPlace={"Amount* (" + (currency)+")"}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Allow only digits (no decimals, no characters)
                    if (/^\d*\.?\d*$/.test(value)) {
                      setLabAmount(value);
                    }
                  }}
                   inputValue={labamount}
                   defaultValue={labamount}
                   maxLength={7}
                />
                
               
              </Box>
              {/* <Box w="100%" display="flex">
                 <PrimaryInput
                  variant="rightSide"
                  inputPlace={"Amount* (" + (currency)+")"}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Allow only digits (no decimals, no characters)
                    if (/^\d*\.?\d*$/.test(value)) {
                      setLabAmount(value);
                    }
                  }}
                   inputValue={labamount}
                   defaultValue={labamount}
                   maxLength={7}
                />
               
              </Box> */}
              <Box w="100%" display="flex">
                <PrimaryInput
                  variant="leftDown"
                  inputPlace="SGST* %"
                  onChange={(e) => {
                    const value = e.target.value;
                    // Allow only digits (no decimals, no characters)
                    if (/^\d*$/.test(value)) {
                      setLabSGST(value);
                    }
                  }}
                   inputValue={labsgst}
                   defaultValue={labsgst}
                   maxLength={3}
                />
                <PrimaryInput
                  variant="rightDown"
                  inputPlace="CGST* %"
                  onChange={(e) => {
                    const value = e.target.value;
                    // Allow only digits (no decimals, no characters)
                    if (/^\d*$/.test(value)) {
                      setLabCGST(value);
                    }
                  }}
                   inputValue={labcgst}
                   defaultValue={labcgst}
                   maxLength={6}
                />
              </Box>

              <Box w="100%" display="flex" mt='2rem'>
                <SimpleTableLabs
                NoDataHeader={false}
                isDataPresent={true}
                ThStyle={{ textAlign: "center", bg: "#FAFAFA" }}
                tableStyle={{
                  h: "calc(100vh - 170px)",
                  maxH: "calc(100vh - 170px)",
                  overflowY: "auto",
                  overflowX: "auto",
                  width: "100%",
                  border: "1px solid #E6E7E9",
                  borderBottom: "none",
                }}
                tableHeaders={
                  <Tr bg='white' zIndex='9999' pos='relative'>
                    <Th fontSize="0.87rem" fontWeight="500" pl="10px">
                      Metric name
                    </Th>
                    <Th fontSize="0.87rem" fontWeight="500" pl="10px">
                      Unit
                    </Th>
                    <Th fontSize="0.87rem" fontWeight="500" pl="10px">
                      Low Range
                    </Th>
                    <Th fontSize="0.87rem" fontWeight="500" pl="10px">
                      High Range
                    </Th>
                    <Th fontSize="0.87rem" fontWeight="500" pl="10px">
                      Formula
                    </Th>
                    {/* <Th fontSize="0.87rem" fontWeight="500" pl="10px">
                      Result
                    </Th> */}
                    <Th fontSize="0.87rem" fontWeight="500" >
                      <Flex w="100%" justifyContent="center" alignItems="center">
                        <PrimaryButton
                          btnIcon="/assets/svgs/add-white.svg"
                          iconSrc={true}
                          btnStyle={{ w: "25px", h: "25px", p: "0",m:"0" }}
                          iconSrcStyle={{ mr: "0", w: "10px" }}
                          onClick={AddAnotherRowLabTest}
                        />
                      </Flex>
                    </Th>
                  </Tr>
                }
                tableBody={
                  <>
                    {rows?.map((row, index) => (
                      <Tr w="100%" key={index}>
                        <Td p="0">
                          <Box w="100%" pos="relative" cursor="pointer">
                            <PrimaryInput
                              variant="bothSide"
                              inputPlace="Metric name"
                              inputValue={row.metricname}
                              id={index === rows.length - 1 ? "LabNameInAdd" : ""}
                              onChange={(e) =>
                                handleMetricNameChange(e.target.value, index)
                              }
                              autocomplete="off"
                              inputCssStyle={{
                                _hover: {
                                  border: "1px solid",
                                  borderRadius: "10px",
                                },
                              }}
                              maxLength={100}
                            />
                          </Box>
                        </Td>
                        <Td p="0">
                          <PrimaryInput
                            variant="bothSide"
                            inputPlace='Unit'
                            inputValue={row.unit}
                            onChange={(e) =>
                              handleUnitChange(e.target.value, index)
                            }
                            maxLength={10}
                            inputCssStyle={{
                              _hover: { border: "1px solid", borderRadius: "10px" },
                            }}
                          />
                        </Td>
                        <Td p="0">
                          <PrimaryInput
                            variant="bothSide"
                            inputPlace="Low Range"
                            inputValue={row.lowrange}
                            onChange={(e) =>
                              handleLowRangeChange(e.target.value, index)
                            }
                            inputCssStyle={{
                              _hover: { border: "1px solid", borderRadius: "10px" },
                            }}
                            maxLength={30}
                          />
                        </Td>
                        <Td p="0">
                          <PrimaryInput
                            variant="bothSide"
                            inputPlace="High Range"
                            inputValue={row.highrange}
                            onChange={(e) =>
                              handleHighRangeChange(e.target.value, index)
                            }
                            inputCssStyle={{
                              _hover: { border: "1px solid", borderRadius: "10px" },
                            }}
                            maxLength={30}
                          />
                        </Td>
                        <Td p="0">
                          <PrimaryInput
                            variant="bothSide"
                            inputPlace="Formula"
                            inputValue={row.formula}
                            onChange={(e) =>
                              handleFormulaChange(e.target.value, index)
                            }
                            inputCssStyle={{
                              _hover: { border: "1px solid", borderRadius: "10px" },
                            }}
                            maxLength={30}
                          />
                        </Td>
                        <Td p="0">
                          <Box
                            as="button"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            w="100%"
                            onClick={() => confirmDeleteRow(index)}
                          >
                            <Image src="/assets/svgs/delete.svg" opacity="0.7" />
                          </Box>
                        </Td>
                      </Tr>
                    ))}
                  </>
                }
            />
              </Box>
            </Box>
          </>
        }
        footerActions={
          <>
            <Box w="100%" display="flex" gap="1rem">
              <PrimaryButton
                buttonText="Cancel"
                variant="grayBtnFull"
                btnStyle={{ color: "#AA2F27" }}
                
                onClick={() => editlabprice.current.closeRight()}
              />

              <PrimaryButton
                buttonText="Save"
                onClick={() => editLabtest()}
              />
            </Box>
          </>
        }
      />
        <DynamicModal
        ref={deletelabprice}
        modalHeader="Delete Lab"
        modalBody={
          <>
            <Text fontSize="14px" fontWeight="600">
              Are you sure you want to delete <b>{labname}</b>?
            </Text>
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              variant="deleteBtn"
              buttonText="Delete"
              onClick={deleteLab}
            />
          </>
        }
      />

{/* ---------------------- new modals for imaging setup ----------------------------- */}

  <ModalRight
          ref={addimagingprice}
          header="Add Imaging"
          modalWidth={{ base: "100%", lg: "calc(100vw - 60%)" }}
          body={
            <>
              <Box w="100%" mt="1rem">
                <Box w="100%" display="flex">
                <PrimaryInput
                    variant="leftSide"
                    inputPlace="Name*"
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits (no decimals, no characters)
                      if (/^[a-zA-Z\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/.test(value)) {
                        setImagingName(value);
                      }
                    }}
                     inputValue={imagingname}
                     defaultValue={imagingname}
                     maxLength={60}
                  />
                   <PrimaryInput
                    variant="rightSide"
                    inputPlace="Description"
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits (no decimals, no characters)
                      // if (/^[a-zA-Z\s]*$/.test(value)) {
                        if (value) {
                        setDescription(value);
                      }
                    }}
                     inputValue={description}
                     defaultValue={description}
                     maxLength={200}
                  />
                  
                 
                </Box>
                <Box w="100%" display="flex">
                <PrimaryInput
                    variant="bothSide"
                    inputPlace={"Amount* (" + (currency)+")"}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits (no decimals, no characters)
                      if (/^\d*\.?\d*$/.test(value)) {
                        setLabAmount(value);
                      }
                    }}
                     inputValue={labamount}
                     defaultValue={labamount}
                     maxLength={7}
                  />
                  </Box>
                <Box w="100%" display="flex">
                  <PrimaryInput
                    variant="leftDown"
                    inputPlace="SGST* %"
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits (no decimals, no characters)
                      if (/^\d*$/.test(value)) {
                        setLabSGST(value);
                      }
                    }}
                     inputValue={labsgst}
                     defaultValue={labsgst}
                     maxLength={3}
                  />
                  <PrimaryInput
                    variant="rightDown"
                    inputPlace="CGST* %"
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits (no decimals, no characters)
                      if (/^\d*$/.test(value)) {
                        setLabCGST(value);
                      }
                    }}
                     inputValue={labcgst}
                     defaultValue={labcgst}
                     maxLength={6}
                  />
                </Box>
              </Box>
            </>
          }
          footerActions={
            <>
              <Box w="100%" display="flex" gap="1rem">
                <PrimaryButton
                  buttonText="Cancel"
                  variant="grayBtnFull"
                  btnStyle={{ color: "#AA2F27" }}
                  
                  onClick={() => addimagingprice.current.closeRight()}
                />
  
                <PrimaryButton
                  buttonText="Save"
                  onClick={() => addImaging()}
                />
              </Box>
            </>
          }
        />
        <ModalRight
          ref={editimagingprice}
          header="Edit Imaging"
          modalWidth={{ base: "100%", lg: "calc(100vw - 60%)" }}
          body={
            <>
              <Box w="100%" mt="1rem">
              <Box w="100%" display="flex">
                <PrimaryInput
                    variant="leftSide"
                    inputPlace="Name*"
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits (no decimals, no characters)
                      if (/^[a-zA-Z\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/.test(value)) {
                        setImagingName(value);
                      }
                    }}
                     inputValue={imagingname}
                    //  defaultValue={imagingname}
                     maxLength={60}
                  />
                   <PrimaryInput
                    variant="rightSide"
                    inputPlace="Description"
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits (no decimals, no characters)
                      // if (/^[a-zA-Z\s]*$/.test(value)) {
                        if (value) {
                        setDescription(value);
                      }
                    }}
                     inputValue={description}
                     defaultValue={description}
                     maxLength={200}
                  />
                  
                 
                </Box>
                <Box w="100%" display="flex">
                   <PrimaryInput
                    variant="bothSide"
                    inputPlace={"Amount* (" + (currency)+")"}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits (no decimals, no characters)
                      if (/^\d*\.?\d*$/.test(value)) {
                        setLabAmount(value);
                      }
                    }}
                     inputValue={labamount}
                     defaultValue={labamount}
                     maxLength={7}
                  />
                 
                </Box>
                <Box w="100%" display="flex">
                  <PrimaryInput
                    variant="leftDown"
                    inputPlace="SGST* %"
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits (no decimals, no characters)
                      if (/^\d*$/.test(value)) {
                        setLabSGST(value);
                      }
                    }}
                     inputValue={labsgst}
                     defaultValue={labsgst}
                     maxLength={3}
                  />
                  <PrimaryInput
                    variant="rightDown"
                    inputPlace="CGST* %"
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits (no decimals, no characters)
                      if (/^\d*$/.test(value)) {
                        setLabCGST(value);
                      }
                    }}
                     inputValue={labcgst}
                     defaultValue={labcgst}
                     maxLength={6}
                  />
                </Box>
              </Box>
            </>
          }
          footerActions={
            <>
              <Box w="100%" display="flex" gap="1rem">
                <PrimaryButton
                  buttonText="Cancel"
                  variant="grayBtnFull"
                  btnStyle={{ color: "#AA2F27" }}
                  
                  onClick={() => editimagingprice.current.closeRight()}
                />
  
                <PrimaryButton
                  buttonText="Save"
                  onClick={() => editImagingtest()}
                />
              </Box>
            </>
          }
        />
  
  <DynamicModal
          ref={deleteimagingprice}
          modalHeader="Delete Imaging"
          modalBody={
            <>
              <Text fontSize="14px" fontWeight="600">
                Are you sure you want to delete <b>{imagingname}</b>?
              </Text>
            </>
          }
          modalFooterBtn={
            <>
              <PrimaryButton
                variant="deleteBtn"
                buttonText="Delete"
                onClick={deleteImaging}
              />
            </>
          }
        />

  <DynamicModal
          ref={deleteRowModal}
          modalHeader="Delete row"
          modalBody={
            <>
              <Text fontSize="14px" fontWeight="600">
                Are you sure you want to delete?
              </Text>
            </>
          }
          modalFooterBtn={
            <>
              <PrimaryButton
                variant="deleteBtn"
                buttonText="Delete"
                onClick={deleteRowHandler}
              />
            </>
          }
        />

{/* ---------------------- new modals for vaccine setup ----------------------------- */}

  <ModalRight
          ref={addvaccineprice}
          header="Add Vaccine"
          modalWidth={{ base: "100%", lg: "calc(100vw - 60%)" }}
          body={
            <>
              <Box w="100%" mt="1rem">
                <Box w="100%" display="flex">
                <PrimaryInput
                    variant="leftSide"
                    inputPlace="Name*"
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits (no decimals, no characters)
                      if (/^[a-zA-Z\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/.test(value)) {
                        setVaccineName(value);
                      }
                    }}
                     inputValue={vaccinename}
                     defaultValue={vaccinename}
                     maxLength={60}
                  />
                   <PrimaryInput
                    variant="rightSide"
                    inputPlace="Description"
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits (no decimals, no characters)
                      // if (/^[a-zA-Z\s]*$/.test(value)) {
                        if (value) {
                        setDescription(value);
                      }
                    }}
                     inputValue={description}
                     defaultValue={description}
                     maxLength={200}
                  />
                  
                 
                </Box>
                <Box w="100%" display="flex">
                <PrimaryInput
                    variant="bothSide"
                    inputPlace={"Amount* (" + (currency)+")"}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits (no decimals, no characters)
                      if (/^\d*\.?\d*$/.test(value)) {
                        setLabAmount(value);
                      }
                    }}
                     inputValue={labamount}
                     defaultValue={labamount}
                     maxLength={7}
                  />
                  </Box>
                <Box w="100%" display="flex">
                  <PrimaryInput
                    variant="leftDown"
                    inputPlace="SGST* %"
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits (no decimals, no characters)
                      if (/^\d*$/.test(value)) {
                        setLabSGST(value);
                      }
                    }}
                     inputValue={labsgst}
                     defaultValue={labsgst}
                     maxLength={3}
                  />
                  <PrimaryInput
                    variant="rightDown"
                    inputPlace="CGST* %"
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits (no decimals, no characters)
                      if (/^\d*$/.test(value)) {
                        setLabCGST(value);
                      }
                    }}
                     inputValue={labcgst}
                     defaultValue={labcgst}
                     maxLength={6}
                  />
                </Box>
              </Box>
            </>
          }
          footerActions={
            <>
              <Box w="100%" display="flex" gap="1rem">
                <PrimaryButton
                  buttonText="Cancel"
                  variant="grayBtnFull"
                  btnStyle={{ color: "#AA2F27" }}
                  
                  onClick={() => addvaccineprice.current.closeRight()}
                />
  
                <PrimaryButton
                  buttonText="Save"
                  onClick={() => addVaccine()}
                />
              </Box>
            </>
          }
        />
        <ModalRight
          ref={editvaccineprice}
          header="Edit Vaccine"
          modalWidth={{ base: "100%", lg: "calc(100vw - 60%)" }}
          body={
            <>
              <Box w="100%" mt="1rem">
              <Box w="100%" display="flex">
                <PrimaryInput
                    variant="leftSide"
                    inputPlace="Name*"
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits (no decimals, no characters)
                      if (/^[a-zA-Z\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/.test(value)) {
                        setVaccineName(value);
                      }
                    }}
                     inputValue={vaccinename}
                    //  defaultValue={vaccinename}
                     maxLength={60}
                  />
                   <PrimaryInput
                    variant="rightSide"
                    inputPlace="Description"
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits (no decimals, no characters)
                      // if (/^[a-zA-Z\s]*$/.test(value)) {
                        if (value) {
                        setDescription(value);
                      }
                    }}
                     inputValue={description}
                     defaultValue={description}
                     maxLength={200}
                  />
                  
                 
                </Box>
                <Box w="100%" display="flex">
                   <PrimaryInput
                    variant="bothSide"
                    inputPlace={"Amount* (" + (currency)+")"}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits (no decimals, no characters)
                      if (/^\d*\.?\d*$/.test(value)) {
                        setLabAmount(value);
                      }
                    }}
                     inputValue={labamount}
                     defaultValue={labamount}
                     maxLength={7}
                  />
                 
                </Box>
                <Box w="100%" display="flex">
                  <PrimaryInput
                    variant="leftDown"
                    inputPlace="SGST* %"
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits (no decimals, no characters)
                      if (/^\d*$/.test(value)) {
                        setLabSGST(value);
                      }
                    }}
                     inputValue={labsgst}
                     defaultValue={labsgst}
                     maxLength={3}
                  />
                  <PrimaryInput
                    variant="rightDown"
                    inputPlace="CGST* %"
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits (no decimals, no characters)
                      if (/^\d*$/.test(value)) {
                        setLabCGST(value);
                      }
                    }}
                     inputValue={labcgst}
                     defaultValue={labcgst}
                     maxLength={6}
                  />
                </Box>
              </Box>
            </>
          }
          footerActions={
            <>
              <Box w="100%" display="flex" gap="1rem">
                <PrimaryButton
                  buttonText="Cancel"
                  variant="grayBtnFull"
                  btnStyle={{ color: "#AA2F27" }}
                  
                  onClick={() => editvaccineprice.current.closeRight()}
                />
  
                <PrimaryButton
                  buttonText="Save"
                  onClick={() => editVaccinetest()}
                />
              </Box>
            </>
          }
        />
  
  <DynamicModal
          ref={deletevaccineprice}
          modalHeader="Delete Vaccine"
          modalBody={
            <>
              <Text fontSize="14px" fontWeight="600">
                Are you sure you want to delete <b>{vaccinename}</b>?
              </Text>
            </>
          }
          modalFooterBtn={
            <>
              <PrimaryButton
                variant="deleteBtn"
                buttonText="Delete"
                onClick={deleteVaccine}
              />
            </>
          }
        />

  <DynamicModal
          ref={deleteRowModal}
          modalHeader="Delete row"
          modalBody={
            <>
              <Text fontSize="14px" fontWeight="600">
                Are you sure you want to delete?
              </Text>
            </>
          }
          modalFooterBtn={
            <>
              <PrimaryButton
                variant="deleteBtn"
                buttonText="Delete"
                onClick={deleteRowHandler}
              />
            </>
          }
        />

{/* ---------------------- new modals for procedure setup ----------------------------- */}

  <ModalRight
          ref={addprocedureprice}
          header="Add Procedure"
          modalWidth={{ base: "100%", lg: "calc(100vw - 60%)" }}
          body={
            <>
              <Box w="100%" mt="1rem">
                <Box w="100%" display="flex">
                <PrimaryInput
                    variant="leftSide"
                    inputPlace="Name*"
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits (no decimals, no characters)
                      if (/^[a-zA-Z\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/.test(value)) {
                        setProcedureName(value);
                      }
                    }}
                     inputValue={procedurename}
                     defaultValue={procedurename}
                     maxLength={60}
                  />
                   <PrimaryInput
                    variant="rightSide"
                    inputPlace="Description"
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits (no decimals, no characters)
                      // if (/^[a-zA-Z\s]*$/.test(value)) {
                        if (value) {
                        setDescription(value);
                      }
                    }}
                     inputValue={description}
                     defaultValue={description}
                     maxLength={200}
                  />
                  
                 
                </Box>
                <Box w="100%" display="flex">
                <PrimaryInput
                    variant="bothSide"
                    inputPlace={"Amount* (" + (currency)+")"}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits (no decimals, no characters)
                      if (/^\d*\.?\d*$/.test(value)) {
                        setLabAmount(value);
                      }
                    }}
                     inputValue={labamount}
                     defaultValue={labamount}
                     maxLength={7}
                  />
                  </Box>
                <Box w="100%" display="flex">
                  <PrimaryInput
                    variant="leftDown"
                    inputPlace="SGST* %"
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits (no decimals, no characters)
                      if (/^\d*$/.test(value)) {
                        setLabSGST(value);
                      }
                    }}
                     inputValue={labsgst}
                     defaultValue={labsgst}
                     maxLength={3}
                  />
                  <PrimaryInput
                    variant="rightDown"
                    inputPlace="CGST* %"
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits (no decimals, no characters)
                      if (/^\d*$/.test(value)) {
                        setLabCGST(value);
                      }
                    }}
                     inputValue={labcgst}
                     defaultValue={labcgst}
                     maxLength={6}
                  />
                </Box>
              </Box>
            </>
          }
          footerActions={
            <>
              <Box w="100%" display="flex" gap="1rem">
                <PrimaryButton
                  buttonText="Cancel"
                  variant="grayBtnFull"
                  btnStyle={{ color: "#AA2F27" }}
                  
                  onClick={() => addprocedureprice.current.closeRight()}
                />
  
                <PrimaryButton
                  buttonText="Save"
                  onClick={() => addProcedure()}
                />
              </Box>
            </>
          }
        />
        <ModalRight
          ref={editprocedureprice}
          header="Edit Procedure"
          modalWidth={{ base: "100%", lg: "calc(100vw - 60%)" }}
          body={
            <>
              <Box w="100%" mt="1rem">
              <Box w="100%" display="flex">
                <PrimaryInput
                    variant="leftSide"
                    inputPlace="Name*"
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits (no decimals, no characters)
                      if (/^[a-zA-Z\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/.test(value)) {
                        setProcedureName(value);
                      }
                    }}
                     inputValue={procedurename}
                    //  defaultValue={procedurename}
                     maxLength={60}
                  />
                   <PrimaryInput
                    variant="rightSide"
                    inputPlace="Description"
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits (no decimals, no characters)
                      // if (/^[a-zA-Z\s]*$/.test(value)) {
                        if (value) {
                        setDescription(value);
                      }
                    }}
                     inputValue={description}
                     defaultValue={description}
                     maxLength={200}
                  />
                  
                 
                </Box>
                <Box w="100%" display="flex">
                   <PrimaryInput
                    variant="bothSide"
                    inputPlace={"Amount* (" + (currency)+")"}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits (no decimals, no characters)
                      if (/^\d*\.?\d*$/.test(value)) {
                        setLabAmount(value);
                      }
                    }}
                     inputValue={labamount}
                     defaultValue={labamount}
                     maxLength={7}
                  />
                 
                </Box>
                <Box w="100%" display="flex">
                  <PrimaryInput
                    variant="leftDown"
                    inputPlace="SGST* %"
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits (no decimals, no characters)
                      if (/^\d*$/.test(value)) {
                        setLabSGST(value);
                      }
                    }}
                     inputValue={labsgst}
                     defaultValue={labsgst}
                     maxLength={3}
                  />
                  <PrimaryInput
                    variant="rightDown"
                    inputPlace="CGST* %"
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits (no decimals, no characters)
                      if (/^\d*$/.test(value)) {
                        setLabCGST(value);
                      }
                    }}
                     inputValue={labcgst}
                     defaultValue={labcgst}
                     maxLength={6}
                  />
                </Box>
              </Box>
            </>
          }
          footerActions={
            <>
              <Box w="100%" display="flex" gap="1rem">
                <PrimaryButton
                  buttonText="Cancel"
                  variant="grayBtnFull"
                  btnStyle={{ color: "#AA2F27" }}
                  
                  onClick={() => editprocedureprice.current.closeRight()}
                />
  
                <PrimaryButton
                  buttonText="Save"
                  onClick={() => editProceduretest()}
                />
              </Box>
            </>
          }
        />
  
  <DynamicModal
          ref={deleteprocedureprice}
          modalHeader="Delete Procedure"
          modalBody={
            <>
              <Text fontSize="14px" fontWeight="600">
                Are you sure you want to delete <b>{procedurename}</b>?
              </Text>
            </>
          }
          modalFooterBtn={
            <>
              <PrimaryButton
                variant="deleteBtn"
                buttonText="Delete"
                onClick={deleteProcedure}
              />
            </>
          }
        />

  <DynamicModal
          ref={deleteRowModal}
          modalHeader="Delete row"
          modalBody={
            <>
              <Text fontSize="14px" fontWeight="600">
                Are you sure you want to delete?
              </Text>
            </>
          }
          modalFooterBtn={
            <>
              <PrimaryButton
                variant="deleteBtn"
                buttonText="Delete"
                onClick={deleteRowHandler}
              />
            </>
          }
        />
      
    </>
  );
};

export default DiagnosticIndex;
